import React from "react";
import colors from "../../config/colors";

function Icon({ type, size = "15", color = colors.primary }) {
  const iconSVGs = {
    terms: (
      <svg
        width={size}
        height={size}
        fill={color}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 96.17 122.88"
      >
        <title>terms-and-services</title>
        <path
          stroke={color}
          d="M62.74,110.31,84.22,87.73H62.74v22.58ZM22.57,45.94V26H16V19.86H35.94V26H29.38v20Zm48.59.21a13.82,13.82,0,0,1-4-.53,6.52,6.52,0,0,1-3-1.93,9.48,9.48,0,0,1-1.93-4,29.06,29.06,0,0,1-.66-6.85,26.2,26.2,0,0,1,.7-6.67,9.71,9.71,0,0,1,2-4,6.71,6.71,0,0,1,3-2,13,13,0,0,1,3.86-.54,27.32,27.32,0,0,1,3.84.23,23,23,0,0,1,2.84.54,12.74,12.74,0,0,1,1.88.63v5.3c-.44-.09-1-.19-1.72-.28s-1.5-.17-2.4-.23-1.88-.09-2.93-.09a7.27,7.27,0,0,0-2,.25,2.35,2.35,0,0,0-1.32,1,5.6,5.6,0,0,0-.72,2.16,25.12,25.12,0,0,0-.23,3.77,28.25,28.25,0,0,0,.18,3.51,6.08,6.08,0,0,0,.63,2.2,2.55,2.55,0,0,0,1.32,1.12,6.28,6.28,0,0,0,2.23.33c1.77,0,3.22,0,4.33-.09s2-.13,2.65-.22V45a12.35,12.35,0,0,1-2,.59,24.09,24.09,0,0,1-2.76.39c-1,.09-2.3.14-3.75.14Zm-25.11.19a10.57,10.57,0,0,1-4.72-1,7.29,7.29,0,0,1-3-2.6,6.46,6.46,0,0,1-1.06-3.6,5.58,5.58,0,0,1,.55-2.54,6.92,6.92,0,0,1,1.53-2,17.25,17.25,0,0,1,2.3-1.82l5.79-3.59a3.23,3.23,0,0,0,1.18-1.14A2.32,2.32,0,0,0,48.89,27a1.57,1.57,0,0,0-.44-1.08,1.81,1.81,0,0,0-1.4-.46,2.25,2.25,0,0,0-1,.21,1.6,1.6,0,0,0-.65.61,1.7,1.7,0,0,0-.24.92,3,3,0,0,0,.43,1.5C47.89,32.94,57.14,42,60.76,45.94H53.88L43.51,35c-.51-.54-1.07-1.2-1.69-2a12.63,12.63,0,0,1-1.58-2.66,7.69,7.69,0,0,1-.67-3.23,7,7,0,0,1,.93-3.55A7.1,7.1,0,0,1,43.12,21a7.92,7.92,0,0,1,3.93-1,7.33,7.33,0,0,1,3.69.89,6.38,6.38,0,0,1,2.4,2.35A6.45,6.45,0,0,1,54,26.5a6.57,6.57,0,0,1-.88,3.32,8.68,8.68,0,0,1-2.51,2.71c-1.51,1.06-5.32,3.42-6.34,4.71a2.15,2.15,0,0,0-.44,1.42,2.2,2.2,0,0,0,.34,1.24,2.12,2.12,0,0,0,1,.78,3.57,3.57,0,0,0,1.45.27,5.63,5.63,0,0,0,2.54-.62,7.73,7.73,0,0,0,2.34-1.73,8.54,8.54,0,0,0,2.35-6h5.43a19.27,19.27,0,0,1-.46,4.27,12.73,12.73,0,0,1-1.48,3.77,9.58,9.58,0,0,1-2.69,2.88l-1,.49-1,.5a10.38,10.38,0,0,1-3.2,1.39,13.9,13.9,0,0,1-3.28.41ZM18.93,90H38.16v5.53H18.93V90Zm0-14H46.22v5.53H18.93V76Zm0-14h58.3v5.53H18.93V61.94ZM96.17,84.85a3.58,3.58,0,0,1-2.61,3.45L61.93,121.56a3.55,3.55,0,0,1-2.76,1.32H6.43A6.42,6.42,0,0,1,0,116.45V6.43A6.42,6.42,0,0,1,6.43,0H89.74a6.44,6.44,0,0,1,6.43,6.43V84.85ZM89,80.55V7.18H7.18V115.73H55.56V84.16a3.61,3.61,0,0,1,3.61-3.61Z"
        />
      </svg>
    ),
    "chevron-down": (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 20"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="icon / 24x24 / ic24-chevron-down">
          <path
            id="Icon"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.0002 7.60017C13.0002 7.75378 12.9458 7.90738 12.8375 8.02438L8.39298 12.8245C8.17575 13.0592 7.82464 13.0592 7.60741 12.8245L3.16292 8.02438C2.94569 7.78978 2.94569 7.41056 3.16292 7.17596C3.38014 6.94135 3.73126 6.94135 3.94848 7.17596L8.00019 11.5519L12.0519 7.17596C12.2691 6.94135 12.6202 6.94135 12.8375 7.17596C12.9458 7.29296 13.0002 7.44656 13.0002 7.60017Z"
            fill={color}
          />
        </g>
      </svg>
    ),
    add: (
      <svg width={size} height={size} viewBox="0 0 15 15" fill="none">
        <line x1="7.25" x2="7.25" y2="15" stroke={color} strokeWidth="2" />
        <line y1="7.75" x2="15" y2="7.75" stroke={color} strokeWidth="2" />
      </svg>
    ),
    print: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
      >
        <path
          d="M14.8334 4.66667H14V0.5H4.00002V4.66667H3.16669C1.78335 4.66667 0.666687 5.78333 0.666687 7.16667V12.1667H4.00002V15.5H14V12.1667H17.3334V7.16667C17.3334 5.78333 16.2167 4.66667 14.8334 4.66667ZM5.66669 2.16667H12.3334V4.66667H5.66669V2.16667ZM12.3334 12.1667V13.8333H5.66669V10.5H12.3334V12.1667ZM14 10.5V8.83333H4.00002V10.5H2.33335V7.16667C2.33335 6.70833 2.70835 6.33333 3.16669 6.33333H14.8334C15.2917 6.33333 15.6667 6.70833 15.6667 7.16667V10.5H14Z"
          fill="#333232"
        />
      </svg>
    ),
    "add-folder": (
      <svg width={size} height={size} viewBox="0 0 17 17" fill="none">
        <path
          d="M10.375 10H6.625"
          stroke={color}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 7.75V12.25C16 15.25 15.25 16 12.25 16H4.75C1.75 16 1 15.25 1 12.25V4.75C1 1.75 1.75 1 4.75 1H5.875C7 1 7.2475 1.33 7.675 1.9L8.8 3.4C9.085 3.775 9.25 4 10 4H12.25C15.25 4 16 4.75 16 7.75Z"
          stroke={color}
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M8.54507 11.875V8.125"
          stroke={color}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    info: (
      <svg
        width={size}
        height={size}
        viewBox="-0.5 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 21.5C17.1086 21.5 21.25 17.3586 21.25 12.25C21.25 7.14137 17.1086 3 12 3C6.89137 3 2.75 7.14137 2.75 12.25C2.75 17.3586 6.89137 21.5 12 21.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.9309 8.15005C12.9256 8.39231 12.825 8.62272 12.6509 8.79123C12.4767 8.95974 12.2431 9.05271 12.0008 9.05002C11.8242 9.04413 11.6533 8.98641 11.5093 8.884C11.3652 8.7816 11.2546 8.63903 11.1911 8.47415C11.1275 8.30927 11.1139 8.12932 11.152 7.95675C11.19 7.78419 11.278 7.6267 11.405 7.50381C11.532 7.38093 11.6923 7.29814 11.866 7.26578C12.0397 7.23341 12.2192 7.25289 12.3819 7.32181C12.5446 7.39072 12.6834 7.506 12.781 7.65329C12.8787 7.80057 12.9308 7.97335 12.9309 8.15005ZM11.2909 16.5301V11.1501C11.2882 11.0556 11.3046 10.9615 11.3392 10.8736C11.3738 10.7857 11.4258 10.7057 11.4922 10.6385C11.5585 10.5712 11.6378 10.518 11.7252 10.4822C11.8126 10.4464 11.9064 10.4286 12.0008 10.43C12.094 10.4299 12.1863 10.4487 12.272 10.4853C12.3577 10.5218 12.4352 10.5753 12.4997 10.6426C12.5642 10.7099 12.6143 10.7895 12.6472 10.8767C12.6801 10.9639 12.6949 11.0569 12.6908 11.1501V16.5301C12.6908 16.622 12.6727 16.713 12.6376 16.7979C12.6024 16.8828 12.5508 16.96 12.4858 17.025C12.4208 17.09 12.3437 17.1415 12.2588 17.1767C12.1738 17.2119 12.0828 17.23 11.9909 17.23C11.899 17.23 11.8079 17.2119 11.723 17.1767C11.6381 17.1415 11.5609 17.09 11.4959 17.025C11.4309 16.96 11.3793 16.8828 11.3442 16.7979C11.309 16.713 11.2909 16.622 11.2909 16.5301Z"
          fill="#000000"
        />
      </svg>
    ),
    chat: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.95931 15.0003L3.0209 18.1511C2.47527 18.5876 1.66699 18.1991 1.66699 17.5003V4.16699C1.66699 2.78628 2.78628 1.66699 4.16699 1.66699H15.8337C17.2144 1.66699 18.3337 2.78628 18.3337 4.16699V12.5003C18.3337 13.881 17.2144 15.0003 15.8337 15.0003H6.95931ZM3.33366 15.7665L6.14641 13.5163C6.29417 13.3981 6.47777 13.3337 6.66699 13.3337H15.8337C16.2939 13.3337 16.667 12.9606 16.667 12.5003V4.16699C16.667 3.70675 16.2939 3.33366 15.8337 3.33366H4.16699C3.70675 3.33366 3.33366 3.70675 3.33366 4.16699V15.7665Z"
          fill={color}
        />
      </svg>
    ),
    filter: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.50021 11.9092L1.79716 2.94723C1.44413 2.39246 1.84264 1.6665 2.50021 1.6665H17.5002C18.1578 1.6665 18.5563 2.39246 18.2033 2.94723L12.5002 11.9092V15.8332C12.5002 16.1488 12.3219 16.4374 12.0396 16.5785L8.70622 18.2452C8.15214 18.5222 7.50021 18.1193 7.50021 17.4998V11.9092ZM4.01827 3.33317L9.0366 11.2191C9.12168 11.3528 9.16688 11.508 9.16688 11.6665V16.1515L10.8335 15.3181V11.6665C10.8335 11.508 10.8787 11.3528 10.9638 11.2191L15.9822 3.33317H4.01827Z"
          fill="white"
        />
      </svg>
    ),

    maximize: (
      <svg width={size} height={size} viewBox="0 0 15 15" fill="none">
        <path
          d="M14 10L20 4M20 4H15.5M20 4V8.5M4 4L10 10M4 4V8.5M4 4H8.5M14 14L20 20M20 20V15.5M20 20H15.5M10 14L4 20M4 20H8.5M4 20L4 15.5"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill={color}
        />
      </svg>
    ),
    minimize: (
      <svg
        fill={color}
        width={"20px"}
        height={"20px"}
        viewBox="0 0 1920 1920"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill-rule="evenodd">
          <path d="M960 0c529.355 0 960 430.645 960 960s-430.645 960-960 960S0 1489.355 0 960 430.645 0 960 0Zm0 112.941c-467.125 0-847.059 379.934-847.059 847.059 0 467.125 379.934 847.059 847.059 847.059 467.125 0 847.059-379.934 847.059-847.059 0-467.125-379.934-847.059-847.059-847.059Z" />
          <path d="M451.765 1016.47h1016.47V903.53H451.765z" />
        </g>
      </svg>
    ),

    premium: (
      <svg width={size} height={size} viewBox="0 0 28 28" fill="none">
        <path
          d="M20.75 3C21.0557 3 21.3421 3.13962 21.5303 3.3746L21.6048 3.48102L25.8548 10.481C26.0556 10.8118 26.0459 11.2249 25.8395 11.5435L25.7634 11.6459L14.7634 24.6459C14.3906 25.0865 13.7317 25.1159 13.3207 24.7341L13.2366 24.6459L2.23662 11.6459C1.98663 11.3505 1.93182 10.941 2.08605 10.5941L2.14522 10.481L6.39522 3.48102C6.55388 3.21969 6.82182 3.04741 7.1204 3.00842L7.25001 3H20.75ZM17.515 12H10.484L13.999 20.672L17.515 12ZM22.844 12H19.673L16.756 19.195L22.844 12ZM8.326 12H5.155L11.242 19.193L8.326 12ZM9.674 5H7.81101L4.775 10H8.245L9.674 5ZM16.246 5H11.753L10.324 10H17.675L16.246 5ZM20.188 5H18.325L19.754 10H23.224L20.188 5Z"
          fill={color}
        />
      </svg>
    ),

    badge: (
      <svg
        fill={color}
        height={size}
        width={size}
        version="1.1"
        id="Capa_1"
        viewBox="0 0 215.777 215.777"
      >
        <path
          d="M198.333,164.99l-17.387-17.388c0.996-0.787,1.905-1.701,2.69-2.779c3.987-5.478,3.017-12.68,2.16-19.033
c-0.541-4.014-1.101-8.163-0.249-10.785c0.784-2.415,3.587-5.327,6.299-8.144c4.536-4.713,9.677-10.054,9.677-17.098
s-5.141-12.386-9.677-17.098c-2.711-2.816-5.515-5.729-6.298-8.143c-0.853-2.623-0.293-6.773,0.248-10.787
c0.856-6.354,1.827-13.555-2.159-19.032c-4.024-5.529-11.215-6.828-17.559-7.973c-3.951-0.714-8.037-1.451-10.213-3.035
c-2.125-1.546-4.062-5.169-5.934-8.673c-3.062-5.726-6.53-12.215-13.119-14.354C135.445,0.226,133.982,0,132.464,0
c-4.885,0-9.621,2.278-14.201,4.48c-3.706,1.783-7.538,3.626-10.397,3.626c-2.86,0-6.691-1.843-10.397-3.626
C92.888,2.278,88.153,0,83.267,0c-1.518,0-2.98,0.226-4.348,0.669C72.331,2.809,68.861,9.298,65.8,15.024
c-1.872,3.503-3.809,7.125-5.933,8.671c-2.176,1.584-6.262,2.321-10.213,3.035c-6.344,1.145-13.534,2.443-17.56,7.974
c-3.986,5.478-3.016,12.679-2.159,19.031c0.541,4.014,1.101,8.164,0.248,10.787c-0.783,2.414-3.587,5.327-6.298,8.144
c-4.536,4.713-9.677,10.054-9.677,17.098c0,7.043,5.141,12.384,9.676,17.096c2.712,2.817,5.516,5.73,6.299,8.145
c0.853,2.623,0.293,6.773-0.248,10.786c-0.856,6.354-1.827,13.555,2.159,19.032c0.792,1.089,1.71,2.008,2.717,2.8L17.444,164.99
c-4.675,4.676-3.81,8.895-3.22,10.491c0.589,1.597,2.67,5.367,9.261,5.887l17.144,1.354c3.045,0.241,5.926,3.122,6.166,6.166
l1.354,17.145c0.567,7.192,5,9.745,8.623,9.745h0.001c1.847,0,4.691-0.643,7.754-3.705l40.059-40.058
c1.178-0.363,2.29-0.594,3.28-0.594c1.009,0,2.143,0.238,3.345,0.613l40.039,40.039c3.062,3.063,5.906,3.705,7.754,3.705
c3.623,0,8.056-2.552,8.624-9.745l1.354-17.144c0.241-3.045,3.122-5.926,6.165-6.167l17.146-1.354
c6.591-0.52,8.672-4.29,9.261-5.887C202.143,173.885,203.008,169.666,198.333,164.99z M124.585,99.641l10.221,31.378l-26.759-19.481
l-26.759,19.422L91.51,99.651L64.751,80.357h33.076l10.221-31.457l10.221,31.457h33.076L124.585,99.641z"
        />
      </svg>
    ),

    request: (
      <svg
        width={size}
        height={size}
        version="1.0"
        id="katman_1"
        x="0px"
        y="0px"
        viewBox="0 0 800 600"
      >
        <path
          stroke={color}
          d="M548.6,507.7H222.2c-8,0-15-2.9-20.9-8.8c-5.9-5.9-8.8-12.8-8.8-20.9V181.3c0-8,2.9-15,8.8-20.9
c5.9-5.9,12.8-8.8,20.9-8.8h29.7v-22.3c0-10.2,3.6-18.9,10.9-26.2c7.3-7.3,16-10.9,26.2-10.9h14.8c10.2,0,18.9,3.6,26.2,10.9
c7.3,7.3,10.9,16,10.9,26.2v22.3h89v-22.3c0-10.2,3.6-18.9,10.9-26.2c7.3-7.3,16-10.9,26.2-10.9h14.8c10.2,0,18.9,3.6,26.2,10.9
c7.3,7.3,10.9,16,10.9,26.2v22.3h29.7c8,0,15,2.9,20.9,8.8c5.9,5.9,8.8,12.8,8.8,20.9v110.9l-30,30H392.9V478h155.8v-89.4l29.7-29.7
V478c0,8-2.9,15-8.8,20.9C563.6,504.8,556.7,507.7,548.6,507.7z M378,411.3h-74.2V478H378V411.3z M289,411.3h-66.8V478H289V411.3z
M476.7,405.9l111.6-111.6L608,314L476.7,445.3L422,390.6l19.7-19.7C441.7,370.9,476.7,405.9,476.7,405.9z M378,322.2h-74.2v74.2
H378V322.2z M289,322.2h-66.8v74.2H289V322.2z M548.6,240.6h-66.8v66.8h66.8V240.6z M467,240.6h-74.2v66.8H467V240.6z M378,240.6
h-74.2v66.8H378V240.6z M289,240.6h-66.8v66.8H289V240.6z M481.9,122H467c-2,0-3.8,0.7-5.2,2.2c-1.5,1.5-2.2,3.2-2.2,5.2v66.8
c0,2,0.7,3.8,2.2,5.2c1.5,1.5,3.2,2.2,5.2,2.2h14.8c2,0,3.7-0.7,5.2-2.2c1.5-1.5,2.2-3.2,2.2-5.2v-66.8c0-2-0.7-3.8-2.2-5.2
C485.6,122.7,483.9,122,481.9,122z M303.8,122H289c-2,0-3.7,0.7-5.2,2.2c-1.5,1.5-2.2,3.2-2.2,5.2v66.8c0,2,0.7,3.8,2.2,5.2
c1.5,1.5,3.2,2.2,5.2,2.2h14.8c2,0,3.8-0.7,5.2-2.2c1.5-1.5,2.2-3.2,2.2-5.2v-66.8c0-2-0.7-3.8-2.2-5.2
C307.6,122.7,305.8,122,303.8,122z"
        />
      </svg>
    ),

    "chat-active": (
      <svg width={size} height={size} viewBox="0 0 21 22" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 3.15789V11.8421H12.6301L12.6316 15L6.90231 11.8421H3.15789V3.15789H15ZM11.0526 0V1.57895H1.57895V7.89474H0V0H11.0526Z"
          fill={color}
        />
        {/* Add the red * (asterisk) */}
        <circle cx="16" cy="17" r="5" fill="#FF0000" />
      </svg>
    ),

    calendar: (
      <svg width={size} height={size} viewBox="0 0 15 15" fill="none">
        <path
          d="M13.3594 2.34375H12.6562V1.40625H11.4844V2.34375H3.51562V1.40625H2.34375V2.34375H1.64062C1.32982 2.34375 1.03175 2.46722 0.811984 2.68698C0.592215 2.90675 0.46875 3.20482 0.46875 3.51562V12.4219C0.46875 12.7327 0.592215 13.0307 0.811984 13.2505C1.03175 13.4703 1.32982 13.5938 1.64062 13.5938H13.3594C13.6702 13.5938 13.9682 13.4703 14.188 13.2505C14.4078 13.0307 14.5312 12.7327 14.5312 12.4219V3.51562C14.5312 3.20482 14.4078 2.90675 14.188 2.68698C13.9682 2.46722 13.6702 2.34375 13.3594 2.34375ZM1.64062 3.51562H13.3594V4.6875H1.64062V3.51562ZM1.64062 12.4219V5.85938H13.3594V12.4219H1.64062Z"
          fill={color}
        />
        <path
          d="M2.8125 7.5H3.84375V8.625H2.8125V7.5ZM2.8125 9.75H3.84375V10.875H2.8125V9.75ZM11.0625 7.5H12.0937V8.625H11.0625V7.5ZM11.0625 9.75H12.0937V10.875H11.0625V9.75ZM9 7.5H10.0312V8.625H9V7.5ZM9 9.75H10.0312V10.875H9V9.75ZM6.9375 7.5H7.96875V8.625H6.9375V7.5ZM6.9375 9.75H7.96875V10.875H6.9375V9.75ZM4.875 7.5H5.90625V8.625H4.875V7.5ZM4.875 9.75H5.90625V10.875H4.875V9.75Z"
          fill={color}
        />
      </svg>
    ),
    send: (
      <svg width={size} height={size} viewBox="0 0 15 15" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9072 0.0517827L1.27515 2.9598C-0.270875 3.34631 -0.463867 5.46538 0.986891 6.12484L4.57079 7.75389C5.30556 8.08783 6.10095 8.2085 6.87389 8.12615C6.79155 8.8991 6.91213 9.69446 7.24615 10.4292L8.8752 14.0131C9.53468 15.4639 11.6537 15.2709 12.0402 13.7249L14.9482 2.09279C15.2564 0.860159 14.1399 -0.256374 12.9072 0.0517827ZM5.19143 6.38844C5.89416 6.70791 6.68071 6.73228 7.38503 6.48248C7.65126 6.38807 7.9057 6.25443 8.13945 6.08277C8.172 6.05885 8.20417 6.03418 8.23589 6.00883L9.95231 4.63568C10.2255 4.41713 10.5829 4.77455 10.3643 5.04773L8.99121 6.76415C8.96579 6.79587 8.94119 6.82804 8.91727 6.86059C8.74561 7.09434 8.61198 7.34879 8.51756 7.61501C8.26769 8.31933 8.29214 9.10585 8.61153 9.8086L10.2406 13.3925C10.3124 13.5504 10.5431 13.5294 10.5852 13.3611L13.4932 1.72903C13.5267 1.59484 13.4052 1.47329 13.271 1.50684L1.63892 4.41486C1.4706 4.45693 1.4496 4.68762 1.60753 4.75941L5.19143 6.38844Z"
          fill={color}
        />
      </svg>
    ),
    save: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
        <path
          d="M4.29412 1H1.875C1.39175 1 1 1.36871 1 1.82353V11.3251C1 11.5666 1.11272 11.7961 1.30831 11.9525L4.87258 14.8039C5.03078 14.9305 5.23165 15 5.43928 15H14.125C14.6083 15 15 14.6313 15 14.1765V1.82353C15 1.36871 14.6083 1 14.125 1H11.7059M4.29412 1V5.11765C4.29412 5.57247 4.68587 5.94118 5.16912 5.94118H10.8309C11.3142 5.94118 11.7059 5.57247 11.7059 5.11765V1M4.29412 1H11.7059"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.375 15V10.8824C5.375 10.4275 5.76675 10.0588 6.25 10.0588H9.75C10.2333 10.0588 10.625 10.4275 10.625 10.8824V15"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    collapse: (
      <svg width={size} height={size} viewBox="0 0 17 11" fill="none">
        <path d="M16 9.5L8.5 2L1 9.5" stroke={color} strokeWidth="2" />
      </svg>
    ),
    expand: (
      <svg width={size} height={size} viewBox="0 0 17 10" fill="none">
        <path d="M1 1L8.5 8.5L16 1" stroke={color} strokeWidth="2" />
      </svg>
    ),
    back: (
      <svg width={size} height={size} viewBox="0 0 10 17" fill="none">
        <path
          d="M9.25 1.25L1.75 8.75L9.25 16.25"
          stroke={color}
          strokeWidth="2"
        />
      </svg>
    ),
    next: (
      <svg width={size} height={size} viewBox="0 0 10 17" fill="none">
        <path
          d="M0.75 16.25L8.25 8.75L0.75 1.25"
          stroke={color}
          strokeWidth="2"
        />
      </svg>
    ),
    tick: (
      <svg width={size} height={size} viewBox="0 0 17 13" fill="none">
        <path
          d="M1 6.71986L5.64019 11.3598L16 1"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    trash: (
      <svg width={size} height={size} viewBox="0 0 15 17" fill="none">
        <path
          d="M1.88235 4.52941V14.2353C1.88235 15.2099 2.67244 16 3.64706 16H10.7059C11.6805 16 12.4706 15.2099 12.4706 14.2353V4.52941M1.88235 4.52941H1M1.88235 4.52941H3.64706M12.4706 4.52941H13.3529M12.4706 4.52941H10.7059M3.64706 4.52941V2.76471C3.64706 1.79009 4.43714 1 5.41176 1H8.94118C9.91582 1 10.7059 1.79009 10.7059 2.76471V4.52941M3.64706 4.52941H10.7059M5.41176 8.05882V12.4706M8.94118 8.05882V12.4706"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    view: (
      <svg width={size} height={size} viewBox="0 0 17 13" fill="none">
        <path
          d="M8.49999 8.69639C9.91687 8.69639 11.0655 7.54779 11.0655 6.13091C11.0655 4.71403 9.91687 3.56543 8.49999 3.56543C7.08311 3.56543 5.93451 4.71403 5.93451 6.13091C5.93451 7.54779 7.08311 8.69639 8.49999 8.69639Z"
          stroke={color}
          strokeWidth="2"
        />
        <path
          d="M15.502 5.21962C15.834 5.62266 16 5.82413 16 6.13096C16 6.43779 15.834 6.63927 15.502 7.04231C14.2876 8.51677 11.6091 11.2619 8.49999 11.2619C5.39086 11.2619 2.71231 8.51677 1.49791 7.04231C1.16597 6.63927 1 6.43779 1 6.13096C1 5.82413 1.16597 5.62266 1.49791 5.21962C2.71231 3.74519 5.39086 1 8.49999 1C11.6091 1 14.2876 3.74519 15.502 5.21962Z"
          stroke={color}
          strokeWidth="2"
        />
      </svg>
    ),
    hide: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.69702 4.6379L8.83969 8.77985C9.13978 8.4899 9.54911 8.31139 10.0003 8.31139C10.9208 8.31139 11.667 9.05428 11.667 9.97068C11.667 10.4228 11.4854 10.8326 11.1909 11.1319L15.3036 15.2445C15.6291 15.5699 15.6291 16.0976 15.3036 16.423C14.9782 16.7485 14.4506 16.7485 14.1251 16.423L13.3751 15.6739C12.3044 16.2939 11.1796 16.6079 10.0003 16.6079C7.01232 16.6079 4.37416 14.5923 2.07859 10.6886L1.90268 10.3846L1.66699 9.97068L1.90268 9.55678C2.60385 8.32543 3.33746 7.27265 4.10373 6.40218L3.51851 5.81641C3.19308 5.49098 3.19308 4.96334 3.51851 4.6379C3.84395 4.31246 4.37159 4.31246 4.69702 4.6379ZM3.78842 9.64101L3.58809 9.97068L3.76146 10.2567C5.72964 13.4489 7.81212 14.9486 10.0003 14.9486C10.7277 14.9486 11.4431 14.7831 12.1461 14.4454L8.99731 11.296C8.87137 11.2014 8.75935 11.0894 8.66484 10.9636L5.28157 7.57851C4.77685 8.16298 4.27909 8.84949 3.78842 9.64101ZM10.0003 3.3335C12.9883 3.3335 15.6265 5.34902 17.9221 9.25277L18.098 9.55678L18.3337 9.97068L17.9264 10.6813C17.2857 11.7716 16.6183 12.7149 15.9241 13.5082L14.7474 12.3314C15.3115 11.6735 15.8667 10.888 16.4126 9.97079C14.3935 6.58205 12.2529 4.99279 10.0003 4.99279C9.28675 4.99279 8.58443 5.15227 7.89364 5.47791L6.66231 4.24635C7.72201 3.6403 8.83454 3.3335 10.0003 3.3335Z"
          fill="#302F2F"
        />
      </svg>
    ),

    edit: (
      <svg width={size} height={size} viewBox="0 0 15 15" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.2337 2.24788C8.66639 2.00282 9.17876 1.93969 9.65801 2.07237C9.87051 2.1312 10.0521 2.23369 10.2232 2.34945C10.3858 2.45938 10.5722 2.60493 10.7883 2.77363L10.8198 2.79824C11.036 2.96693 11.2225 3.11248 11.3686 3.24349C11.5224 3.38142 11.6659 3.53268 11.7746 3.72454C12.0196 4.15724 12.0828 4.66958 11.9501 5.14883C11.8913 5.36132 11.7888 5.5429 11.673 5.71405C11.5631 5.87661 11.4175 6.06308 11.2488 6.2792L6.80958 11.9663C6.79833 11.9806 6.78726 11.9948 6.77633 12.0089C6.56795 12.2761 6.41039 12.4781 6.21533 12.644C6.05024 12.7844 5.86758 12.9028 5.67196 12.9961C5.44086 13.1064 5.1921 13.1677 4.86304 13.2488C4.84579 13.2531 4.82831 13.2574 4.81061 13.2618L3.4826 13.5896C3.39063 13.6123 3.28565 13.6383 3.19305 13.6525C3.08981 13.6684 2.92995 13.6828 2.75338 13.6263C2.54113 13.5583 2.36003 13.4169 2.24257 13.2275C2.14486 13.0699 2.12 12.9114 2.11033 12.8074C2.10165 12.7141 2.10135 12.6059 2.10108 12.5112C2.10106 12.5053 2.10105 12.4995 2.10103 12.4938L2.09673 11.1433C2.09667 11.1251 2.09661 11.1071 2.09655 11.0893C2.09533 10.7504 2.09441 10.4942 2.14526 10.2433C2.18831 10.0308 2.2588 9.82488 2.35496 9.6307C2.46856 9.4012 2.62629 9.19932 2.83493 8.93226C2.84586 8.91826 2.85695 8.90407 2.86817 8.8897L7.30739 3.2026C7.47608 2.98648 7.62164 2.8 7.75264 2.65388C7.89058 2.50004 8.04183 2.35654 8.2337 2.24788ZM9.32445 3.27705C9.1647 3.23283 8.99395 3.25387 8.8497 3.33556C8.8252 3.34943 8.7787 3.38198 8.68339 3.48832C8.58426 3.59886 8.46489 3.7512 8.28045 3.9875L10.2511 5.52579C10.4356 5.2895 10.5544 5.13673 10.6376 5.01377C10.7176 4.89545 10.7379 4.84243 10.7454 4.8153C10.7896 4.65555 10.7686 4.48478 10.6869 4.34054C10.673 4.31605 10.6405 4.26954 10.5341 4.1742C10.4236 4.07509 10.2713 3.95575 10.035 3.7713C9.79864 3.58685 9.64589 3.46803 9.52295 3.38487C9.40464 3.30485 9.35158 3.28457 9.32445 3.27705ZM9.48201 6.51113L7.51133 4.97285L3.85352 9.65882C3.59742 9.98688 3.5252 10.0843 3.47521 10.1853C3.42713 10.2824 3.39188 10.3853 3.37036 10.4915C3.34798 10.6019 3.3454 10.7231 3.34673 11.1393L3.35053 12.3347L4.51101 12.0482C4.91508 11.9484 5.03201 11.9165 5.13371 11.8679C5.23152 11.8213 5.32285 11.7621 5.4054 11.6919C5.49122 11.6189 5.56812 11.5252 5.82421 11.1971L9.48201 6.51113ZM7.50001 13.1249C7.50001 12.7797 7.77983 12.4999 8.12501 12.4999H12.5C12.8452 12.4999 13.125 12.7797 13.125 13.1249C13.125 13.4701 12.8452 13.7499 12.5 13.7499H8.12501C7.77983 13.7499 7.50001 13.4701 7.50001 13.1249Z"
          fill={color}
        />
      </svg>
    ),
    cross: (
      <svg width={size} height={size} viewBox="0 0 15 15" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7559 1.42259C15.0814 1.09716 15.0814 0.56951 14.7559 0.244075C14.4305 -0.0813586 13.9029 -0.0813586 13.5775 0.244075L7.50001 6.32153L1.42259 0.244075C1.09716 -0.0813586 0.56951 -0.0813586 0.244076 0.244075C-0.0813584 0.56951 -0.0813584 1.09716 0.244076 1.42259L6.32153 7.50001L0.244074 13.5775C-0.0813599 13.9029 -0.0813598 14.4305 0.244085 14.7559C0.569519 15.0814 1.09715 15.0814 1.4226 14.7559L7.50001 8.67849L13.5775 14.7559C13.9029 15.0814 14.4305 15.0814 14.7559 14.7559C15.0814 14.4305 15.0814 13.9029 14.7559 13.5775L8.67849 7.50001L14.7559 1.42259Z"
          fill={color}
        />
      </svg>
    ),
    like: (
      <svg width={size} height={size} viewBox="0 0 15 15" fill="none">
        <path
          d="M5.24414 11.5567V5.20669C5.24414 4.95669 5.31914 4.71294 5.45664 4.50669L7.16288 1.96919C7.43163 1.56294 8.10038 1.27544 8.66913 1.48794C9.28163 1.69419 9.68788 2.38169 9.55663 2.99419L9.23163 5.03794C9.20663 5.22544 9.25663 5.39419 9.36288 5.52544C9.46913 5.64419 9.62538 5.71919 9.79413 5.71919H12.3629C12.8566 5.71919 13.2816 5.91919 13.5316 6.26919C13.7691 6.60669 13.8129 7.04419 13.6566 7.48794L12.1191 12.1692C11.9254 12.9442 11.0816 13.5754 10.2441 13.5754H7.80663C7.38788 13.5754 6.80038 13.4317 6.53163 13.1629L5.73164 12.5442C5.42539 12.3129 5.24414 11.9442 5.24414 11.5567Z"
          fill={color}
        />
        <path
          d="M3.25625 3.98682H2.6125C1.64375 3.98682 1.25 4.36182 1.25 5.28682V11.5743C1.25 12.4993 1.64375 12.8743 2.6125 12.8743H3.25625C4.225 12.8743 4.61875 12.4993 4.61875 11.5743V5.28682C4.61875 4.36182 4.225 3.98682 3.25625 3.98682Z"
          fill={color}
        />
      </svg>
    ),
    time: (
      <svg width={size} height={size} viewBox="0 0 15 15" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 1.5C4.18629 1.5 1.5 4.18629 1.5 7.5C1.5 10.8137 4.18629 13.5 7.5 13.5C10.8137 13.5 13.5 10.8137 13.5 7.5C13.5 4.18629 10.8137 1.5 7.5 1.5ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM7.3713 3.56802C7.78552 3.56802 8.1213 3.9038 8.1213 4.31802V8.04337L10.7665 9.04897C11.1537 9.19612 11.3483 9.62932 11.201 10.0165C11.0539 10.4037 10.6207 10.5983 10.2335 10.451L7.10482 9.26175C6.81375 9.15105 6.6213 8.87205 6.6213 8.56065V4.31802C6.6213 3.9038 6.95707 3.56802 7.3713 3.56802Z"
          fill={color}
        />
      </svg>
    ),

    upload: (
      <svg width={size} height={size} viewBox="0 0 15 15" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.712891 -0.287842C0.160606 -0.287842 -0.287109 0.159873 -0.287109 0.712158C-0.287109 1.26444 0.160606 1.71216 0.712891 1.71216H13.714C14.2663 1.71216 14.714 1.26444 14.714 0.712158C14.714 0.159873 14.2663 -0.287842 13.714 -0.287842H0.712891ZM7.91201 2.8872C7.52027 2.50406 6.89314 2.50754 6.50568 2.895L2.89488 6.5058C2.50436 6.89633 2.50436 7.52949 2.89488 7.92001C3.28541 8.31054 3.91857 8.31054 4.30909 7.92001L6.21279 6.01632V13.7141C6.21279 14.2664 6.6605 14.7141 7.21279 14.7141C7.76507 14.7141 8.21279 14.2664 8.21279 13.7141V5.97895L10.2054 7.92781C10.6002 8.31398 11.2333 8.30696 11.6195 7.91213C12.0057 7.51729 11.9986 6.88417 11.6038 6.498L7.91201 2.8872Z"
          fill={color}
        />
      </svg>
    ),
    uploadIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <g id="Upload">
          <path
            id="Stroke 1"
            d="M5.1579 6.48661H4.3804C2.68457 6.48661 1.30957 7.86161 1.30957 9.55744L1.30957 13.6199C1.30957 15.3149 2.68457 16.6899 4.3804 16.6899H13.6554C15.3512 16.6899 16.7262 15.3149 16.7262 13.6199V9.54911C16.7262 7.85827 15.3554 6.48661 13.6646 6.48661H12.8787"
            stroke={color ? color : " #44449B"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Stroke 3"
            d="M9.01823 0.825208V10.8594"
            stroke={color ? color : " #44449B"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Stroke 5"
            d="M6.58887 3.26562L9.01803 0.825625L11.448 3.26563"
            stroke={color ? color : " #44449B"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    ),
    copy: (
      <svg fill={color} height={size} width={size} viewBox="0 0 442 442">
        <polygon points="291,0 51,0 51,332 121,332 121,80 291,80 	" />
        <polygon points="306,125 306,195 376,195 	" />
        <polygon points="276,225 276,110 151,110 151,442 391,442 391,225 	" />
      </svg>
    ),

    show: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill={color}
        viewBox="0 0 30 30"
        width={size}
        height={size}
      >
        <path d="M 1.7070312 0.29296875 L 0.29296875 1.7070312 L 28.292969 29.707031 L 29.707031 28.292969 L 23.681641 22.267578 C 27.777456 19.49434 29.799165 15.616636 29.826172 15.564453 A 1 1 0 0 0 30 15 A 1 1 0 0 0 29.783203 14.378906 C 29.679012 14.21118 23.918297 5 15 5 C 12.469857 5 10.199331 5.7501922 8.234375 6.8203125 L 1.7070312 0.29296875 z M 15 8 C 18.866 8 22 11.134 22 15 C 22 16.571956 21.470043 18.012848 20.59375 19.179688 L 18.439453 17.025391 C 18.792987 16.432111 19 15.741719 19 15 C 19 12.791 17.209 11 15 11 C 14.258281 11 13.567889 11.207013 12.974609 11.560547 L 10.820312 9.40625 C 11.987152 8.5299565 13.428044 8 15 8 z M 4.9511719 9.0761719 C 1.9791583 11.576125 0.27498083 14.287031 0.21875 14.376953 A 1 1 0 0 0 0 15 A 1 1 0 0 0 0.16601562 15.550781 C 0.18320928 15.586261 5.0188313 25 15 25 C 16.85 25 18.520531 24.673484 20.019531 24.146484 L 17.431641 21.556641 C 16.672641 21.838641 15.856 22 15 22 C 11.134 22 8 18.866 8 15 C 8 14.144 8.1613594 13.327359 8.4433594 12.568359 L 4.9511719 9.0761719 z M 11.011719 15.111328 C 11.071719 17.228328 12.769719 18.928281 14.886719 18.988281 L 11.011719 15.111328 z" />
      </svg>
    ),

    loading: (
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <g transform="translate(84,50)">
          <g transform="rotate(0)">
            <circle cx="0" cy="0" r="6" fill={color} fillOpacity="1">
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.9s"
                values="1.5 1.5;1 1"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
              <animate
                attributeName="fill-opacity"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
                values="1;0"
                begin="-0.9s"
              ></animate>
            </circle>
          </g>
        </g>
        <g transform="translate(77.5065778087482,69.98469857794409)">
          <g transform="rotate(36)">
            <circle cx="0" cy="0" r="6" fill={color} fillOpacity="0.9">
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.8s"
                values="1.5 1.5;1 1"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
              <animate
                attributeName="fill-opacity"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
                values="1;0"
                begin="-0.8s"
              ></animate>
            </circle>
          </g>
        </g>
        <g transform="translate(60.50657780874821,82.33592155403522)">
          <g transform="rotate(72)">
            <circle cx="0" cy="0" r="6" fill={color} fillOpacity="0.8">
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.7s"
                values="1.5 1.5;1 1"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
              <animate
                attributeName="fill-opacity"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
                values="1;0"
                begin="-0.7s"
              ></animate>
            </circle>
          </g>
        </g>
        <g transform="translate(39.49342219125179,82.33592155403522)">
          <g transform="rotate(108)">
            <circle cx="0" cy="0" r="6" fill={color} fillOpacity="0.7">
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.6s"
                values="1.5 1.5;1 1"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
              <animate
                attributeName="fill-opacity"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
                values="1;0"
                begin="-0.6s"
              ></animate>
            </circle>
          </g>
        </g>
        <g transform="translate(22.493422191251792,69.98469857794409)">
          <g transform="rotate(144)">
            <circle cx="0" cy="0" r="6" fill={color} fillOpacity="0.6">
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.5s"
                values="1.5 1.5;1 1"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
              <animate
                attributeName="fill-opacity"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
                values="1;0"
                begin="-0.5s"
              ></animate>
            </circle>
          </g>
        </g>
        <g transform="translate(16,50)">
          <g transform="rotate(180)">
            <circle cx="0" cy="0" r="6" fill={color} fillOpacity="0.5">
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.4s"
                values="1.5 1.5;1 1"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
              <animate
                attributeName="fill-opacity"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
                values="1;0"
                begin="-0.4s"
              ></animate>
            </circle>
          </g>
        </g>
        <g transform="translate(22.49342219125179,30.015301422055916)">
          <g transform="rotate(216)">
            <circle cx="0" cy="0" r="6" fill={color} fillOpacity="0.4">
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.3s"
                values="1.5 1.5;1 1"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
              <animate
                attributeName="fill-opacity"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
                values="1;0"
                begin="-0.3s"
              ></animate>
            </circle>
          </g>
        </g>
        <g transform="translate(39.49342219125178,17.664078445964783)">
          <g transform="rotate(252)">
            <circle cx="0" cy="0" r="6" fill={color} fillOpacity="0.3">
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.2s"
                values="1.5 1.5;1 1"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
              <animate
                attributeName="fill-opacity"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
                values="1;0"
                begin="-0.2s"
              ></animate>
            </circle>
          </g>
        </g>
        <g transform="translate(60.506577808748204,17.664078445964776)">
          <g transform="rotate(288)">
            <circle cx="0" cy="0" r="6" fill={color} fillOpacity="0.2">
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.1s"
                values="1.5 1.5;1 1"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
              <animate
                attributeName="fill-opacity"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
                values="1;0"
                begin="-0.1s"
              ></animate>
            </circle>
          </g>
        </g>
        <g transform="translate(77.5065778087482,30.015301422055906)">
          <g transform="rotate(324)">
            <circle cx="0" cy="0" r="6" fill={color} fillOpacity="0.1">
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="0s"
                values="1.5 1.5;1 1"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
              <animate
                attributeName="fill-opacity"
                keyTimes="0;1"
                dur="1s"
                repeatCount="indefinite"
                values="1;0"
                begin="0s"
              ></animate>
            </circle>
          </g>
        </g>
      </svg>
    ),
    "notification-active": (
      <svg width={size} height={size} viewBox="0 0 21 22" fill="none">
        <path
          d="M8.97917 20.9166C10.125 20.9166 11.0625 19.9791 11.0625 18.8333H6.89583C6.89583 19.9791 7.83333 20.9166 8.97917 20.9166ZM15.75 14.6666V8.93742C15.75 5.7395 13.5312 3.06242 10.5417 2.35408V1.64575C10.5417 0.781169 9.84375 0.083252 8.97917 0.083252C8.11458 0.083252 7.41667 0.781169 7.41667 1.64575V2.35408C4.42708 3.06242 2.20833 5.7395 2.20833 8.93742V14.6666L0.125 16.7499V17.7916H17.8333V16.7499L15.75 14.6666Z"
          fill={color}
        />
        <circle cx="16" cy="17" r="5" fill="#FF0000" />
      </svg>
    ),
    notification: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1_9434)">
          <path
            d="M9.99967 18.333C10.9163 18.333 11.6663 17.583 11.6663 16.6663H8.33301C8.33301 17.583 9.08301 18.333 9.99967 18.333ZM14.9997 13.333V9.16634C14.9997 6.60801 13.6413 4.46634 11.2497 3.89967V3.33301C11.2497 2.64134 10.6913 2.08301 9.99967 2.08301C9.30801 2.08301 8.74967 2.64134 8.74967 3.33301V3.89967C6.36634 4.46634 4.99967 6.59967 4.99967 9.16634V13.333L3.33301 14.9997V15.833H16.6663V14.9997L14.9997 13.333ZM13.333 14.1663H6.66634V9.16634C6.66634 7.09967 7.92467 5.41634 9.99967 5.41634C12.0747 5.41634 13.333 7.09967 13.333 9.16634V14.1663Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_1_9434">
            <rect width="20" height="20" fill={color} />
          </clipPath>
        </defs>
      </svg>
    ),
    user: (
      <svg width={size} height={size} viewBox="0 0 20 20">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-140.000000, -2159.000000)" fill={color}>
            <g transform="translate(56.000000, 160.000000)">
              <path d="M100.562548,2016.99998 L87.4381713,2016.99998 C86.7317804,2016.99998 86.2101535,2016.30298 86.4765813,2015.66198 C87.7127655,2012.69798 90.6169306,2010.99998 93.9998492,2010.99998 C97.3837885,2010.99998 100.287954,2012.69798 101.524138,2015.66198 C101.790566,2016.30298 101.268939,2016.99998 100.562548,2016.99998 M89.9166645,2004.99998 C89.9166645,2002.79398 91.7489936,2000.99998 93.9998492,2000.99998 C96.2517256,2000.99998 98.0830339,2002.79398 98.0830339,2004.99998 C98.0830339,2007.20598 96.2517256,2008.99998 93.9998492,2008.99998 C91.7489936,2008.99998 89.9166645,2007.20598 89.9166645,2004.99998 M103.955674,2016.63598 C103.213556,2013.27698 100.892265,2010.79798 97.837022,2009.67298 C99.4560048,2008.39598 100.400241,2006.33098 100.053171,2004.06998 C99.6509769,2001.44698 97.4235996,1999.34798 94.7348224,1999.04198 C91.0232075,1998.61898 87.8750721,2001.44898 87.8750721,2004.99998 C87.8750721,2006.88998 88.7692896,2008.57398 90.1636971,2009.67298 C87.1074334,2010.79798 84.7871636,2013.27698 84.044024,2016.63598 C83.7745338,2017.85698 84.7789973,2018.99998 86.0539717,2018.99998 L101.945727,2018.99998 C103.221722,2018.99998 104.226185,2017.85698 103.955674,2016.63598"></path>
            </g>
          </g>
        </g>
      </svg>
    ),
    security: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path
          d="M20.9098 11.1203V6.73031C20.9098 5.91031 20.2898 4.98031 19.5198 4.67031L13.9498 2.39031C12.6998 1.88031 11.2898 1.88031 10.0398 2.39031L4.46984 4.67031C3.70984 4.98031 3.08984 5.91031 3.08984 6.73031V11.1203C3.08984 16.0103 6.63984 20.5903 11.4898 21.9303C11.8198 22.0203 12.1798 22.0203 12.5098 21.9303C17.3598 20.5903 20.9098 16.0103 20.9098 11.1203ZM12.7498 12.8703V15.5003C12.7498 15.9103 12.4098 16.2503 11.9998 16.2503C11.5898 16.2503 11.2498 15.9103 11.2498 15.5003V12.8703C10.2398 12.5503 9.49984 11.6103 9.49984 10.5003C9.49984 9.12031 10.6198 8.00031 11.9998 8.00031C13.3798 8.00031 14.4998 9.12031 14.4998 10.5003C14.4998 11.6203 13.7598 12.5503 12.7498 12.8703Z"
          fill={color}
        />
      </svg>
    ),
    "vertical-dots": (
      <svg width={size} height={size} viewBox="0 0 15 15" fill="none">
        <path
          d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
          fill={color}
        />
      </svg>
    ),
    "right-arrow": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 17 15"
        fill="none"
      >
        <path
          d="M15.75 7.72559L0.75 7.72559"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.7002 1.70124L15.7502 7.72524L9.7002 13.7502"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    search: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 2C15.9706 2 20 6.02944 20 11C20 13.1248 19.2637 15.0776 18.0323 16.6172L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3466 22.0676 20.7794 22.0953 20.3871 21.7903L20.2929 21.7071L16.6172 18.0323C15.0776 19.2637 13.1248 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2ZM11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4Z"
          fill="#B3B3B3"
        />
      </svg>
    ),
    plus: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 4C12.5523 4 13 4.44772 13 5V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11V5C11 4.44772 11.4477 4 12 4Z"
          fill="white"
        />
      </svg>
    ),
    mentor: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
      >
        <g clip-path="url(#clip0_1_34718)">
          <path
            d="M30 45.8334C22.2 45.8334 6.66663 49.7334 6.66663 57.5001V63.3334H53.3333V57.5001C53.3333 49.7334 37.8 45.8334 30 45.8334ZM14.4666 56.6667C17.2666 54.7334 24.0333 52.5001 30 52.5001C35.9666 52.5001 42.7333 54.7334 45.5333 56.6667H14.4666ZM30 40.0001C36.4333 40.0001 41.6666 34.7667 41.6666 28.3334C41.6666 21.9001 36.4333 16.6667 30 16.6667C23.5666 16.6667 18.3333 21.9001 18.3333 28.3334C18.3333 34.7667 23.5666 40.0001 30 40.0001ZM30 23.3334C32.7666 23.3334 35 25.5667 35 28.3334C35 31.1001 32.7666 33.3334 30 33.3334C27.2333 33.3334 25 31.1001 25 28.3334C25 25.5667 27.2333 23.3334 30 23.3334ZM53.4666 46.0334C57.3333 48.8334 60 52.5667 60 57.5001V63.3334H73.3333V57.5001C73.3333 50.7668 61.6666 46.9334 53.4666 46.0334ZM50 40.0001C56.4333 40.0001 61.6666 34.7667 61.6666 28.3334C61.6666 21.9001 56.4333 16.6667 50 16.6667C48.2 16.6667 46.5333 17.1001 45 17.8334C47.1 20.8001 48.3333 24.4334 48.3333 28.3334C48.3333 32.2334 47.1 35.8667 45 38.8334C46.5333 39.5667 48.2 40.0001 50 40.0001Z"
            fill="#44449B"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_34718">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    mentees: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23.3333 46.6666H26.6666C32.1191 46.6666 36.96 49.2848 40.0007 53.3326C42.88 49.4979 47.3763 46.9462 52.4776 46.6882L53.3333 46.6666H56.6666C65.8714 46.6666 73.3333 54.1285 73.3333 63.3333C73.3333 65.1742 71.8409 66.6666 70 66.6666C68.2905 66.6666 66.8816 65.3798 66.6891 63.722L66.6497 62.7457C66.3568 57.6907 62.3091 53.6431 57.2542 53.3502L56.6666 53.3333H53.3333C47.8104 53.3333 43.3333 57.8104 43.3333 63.3333C43.3333 65.0427 42.0465 66.4516 40.3887 66.6442L40 66.6666C38.2905 66.6666 36.8816 65.3798 36.6891 63.722L36.6497 62.7457C36.3568 57.6907 32.3091 53.6431 27.2542 53.3502L26.6666 53.3333H23.3333C17.8104 53.3333 13.3333 57.8104 13.3333 63.3333C13.3333 65.1742 11.8409 66.6666 9.99996 66.6666C8.15901 66.6666 6.66663 65.1742 6.66663 63.3333C6.66663 54.3707 13.741 47.0605 22.6103 46.682L23.3333 46.6666ZM23.3333 13.3333C30.6971 13.3333 36.6666 19.3028 36.6666 26.6666C36.6666 34.0304 30.6971 39.9999 23.3333 39.9999C15.9695 39.9999 9.99996 34.0304 9.99996 26.6666C9.99996 19.3028 15.9695 13.3333 23.3333 13.3333ZM56.6666 13.3333C64.0304 13.3333 70 19.3028 70 26.6666C70 34.0304 64.0304 39.9999 56.6666 39.9999C49.3028 39.9999 43.3333 34.0304 43.3333 26.6666C43.3333 19.3028 49.3028 13.3333 56.6666 13.3333ZM23.3333 19.9999C19.6514 19.9999 16.6666 22.9847 16.6666 26.6666C16.6666 30.3485 19.6514 33.3333 23.3333 33.3333C27.0152 33.3333 30 30.3485 30 26.6666C30 22.9847 27.0152 19.9999 23.3333 19.9999ZM56.6666 19.9999C52.9847 19.9999 50 22.9847 50 26.6666C50 30.3485 52.9847 33.3333 56.6666 33.3333C60.3485 33.3333 63.3333 30.3485 63.3333 26.6666C63.3333 22.9847 60.3485 19.9999 56.6666 19.9999Z"
          fill="#44449B"
        />
      </svg>
    ),
    close: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.4652 9.67587L15.5831 5.93602C15.8873 5.65975 15.8873 5.2132 15.5831 4.93694C15.2789 4.66067 14.7872 4.66067 14.483 4.93694L10.3651 8.67679L6.24717 4.93694C5.94298 4.66067 5.45129 4.66067 5.14709 4.93694C4.8429 5.2132 4.8429 5.65975 5.14709 5.93602L9.26501 9.67587L5.14709 13.4157C4.8429 13.692 4.8429 14.1385 5.14709 14.4148C5.2988 14.5526 5.49797 14.6218 5.69713 14.6218C5.8963 14.6218 6.09547 14.5526 6.24717 14.4148L10.3651 10.675L14.483 14.4148C14.6347 14.5526 14.8339 14.6218 15.0331 14.6218C15.2322 14.6218 15.4314 14.5526 15.5831 14.4148C15.8873 14.1385 15.8873 13.692 15.5831 13.4157L11.4652 9.67587Z"
          fill="#252421"
        />
      </svg>
    ),
    multichoice: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1"
          y="1"
          width="18"
          height="18"
          rx="9"
          stroke="#302F2F"
          stroke-width="2"
        />
        <circle cx="10" cy="10" r="4" fill="#302F2F" />
      </svg>
    ),
    "search-icon": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 2C15.9706 2 20 6.02944 20 11C20 13.1248 19.2637 15.0776 18.0323 16.6172L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3466 22.0676 20.7794 22.0953 20.3871 21.7903L20.2929 21.7071L16.6172 18.0323C15.0776 19.2637 13.1248 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2ZM11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4Z"
          fill="#B3B3B3"
        />
      </svg>
    ),
    comment: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.0412 15.0001L16.9796 18.1508C17.5252 18.5873 18.3335 18.1988 18.3335 17.5001V4.16675C18.3335 2.78604 17.2142 1.66675 15.8335 1.66675H4.16683C2.78612 1.66675 1.66683 2.78604 1.66683 4.16675V12.5001C1.66683 13.8808 2.78612 15.0001 4.16683 15.0001H13.0412ZM16.6668 15.7662L13.8541 13.516C13.7063 13.3978 13.5227 13.3334 13.3335 13.3334H4.16683C3.70659 13.3334 3.3335 12.9603 3.3335 12.5001V4.16675C3.3335 3.70651 3.70659 3.33341 4.16683 3.33341H15.8335C16.2937 3.33341 16.6668 3.70651 16.6668 4.16675V15.7662Z"
          fill="#4C4B9A"
        />
      </svg>
    ),
    mentorGraph: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="175"
        height="175"
        viewBox="0 0 175 175"
        fill="none"
      >
        <path
          d="M14.3185 135.466C4.83178 120.992 -0.149911 104.03 0.00343113 86.7247C0.156773 69.4195 5.43825 52.5484 15.18 38.2449C24.9217 23.9413 38.6862 12.8477 54.7328 6.36702C70.7794 -0.113727 88.3874 -1.69056 105.33 1.8359L96.4151 44.6679C87.9437 42.9047 79.1397 43.6931 71.1164 46.9335C63.0931 50.1739 56.2109 55.7207 51.34 62.8724C46.4691 70.0242 43.8284 78.4597 43.7517 87.1123C43.675 95.7649 46.1659 104.246 50.9093 111.483L14.3185 135.466Z"
          fill="#51D1FF"
        />
        <path
          d="M66.4842 172.439C52.5386 168.988 39.6572 162.157 28.9772 152.549C18.2973 142.94 10.1474 130.85 5.24732 117.345C0.347198 103.841 -1.15246 89.3375 0.88078 75.1161C2.91402 60.8946 8.41759 47.3926 16.9055 35.8021L52.2028 61.6511C47.9588 67.4463 45.207 74.1973 44.1904 81.308C43.1738 88.4188 43.9236 95.6704 46.3737 102.423C48.8237 109.175 52.8986 115.22 58.2386 120.024C63.5786 124.829 70.0193 128.244 76.9921 129.969L66.4842 172.439Z"
          fill="#4A95FF"
        />
        <path
          d="M153.239 145.246C145.258 154.332 135.479 161.665 124.521 166.782C113.562 171.899 101.662 174.689 89.5714 174.975C77.4806 175.262 65.4617 173.038 54.2734 168.446C43.0851 163.853 32.9703 156.991 24.5676 148.293L56.0338 117.896C60.2352 122.246 65.2925 125.677 70.8867 127.973C76.4808 130.269 82.4903 131.381 88.5357 131.238C94.5811 131.095 100.531 129.7 106.01 127.141C111.49 124.583 116.379 120.916 120.37 116.373L153.239 145.246Z"
          fill="#F7A61B"
        />
        <path
          d="M169.643 57.3535C174.267 69.9533 175.931 83.4479 174.505 96.7934C173.08 110.139 168.603 122.978 161.422 134.317C154.241 145.655 144.548 155.19 133.092 162.183C121.636 169.177 108.726 173.441 95.3585 174.646L91.4292 131.073C98.1129 130.47 104.568 128.338 110.296 124.842C116.024 121.345 120.87 116.578 124.461 110.908C128.052 105.239 130.29 98.8195 131.003 92.1467C131.715 85.4739 130.883 78.7266 128.571 72.4268L169.643 57.3535Z"
          fill="#AE681C"
        />
        <path
          d="M102.407 1.27909C118.203 4.01007 132.945 11.028 145.025 21.5669C157.104 32.1057 166.056 45.7604 170.903 61.0404C175.751 76.3205 176.308 92.6386 172.513 108.213C168.718 123.788 160.718 138.021 149.385 149.359L118.442 118.43C124.109 112.761 128.109 105.644 130.006 97.8567C131.904 90.0693 131.626 81.9102 129.202 74.2702C126.778 66.6302 122.302 59.8029 116.262 54.5334C110.223 49.264 102.851 45.755 94.9533 44.3895L102.407 1.27909Z"
          fill="#4D4D9F"
        />
        <g filter="url(#filter0_d_1_36837)">
          <circle cx="88.0827" cy="88.0837" r="44.9167" fill="white" />
        </g>
        <defs>
          <filter
            id="filter0_d_1_36837"
            x="3.16602"
            y="3.16699"
            width="169.833"
            height="169.833"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="20" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1_36837"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1_36837"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    exportAll: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <g clip-path="url(#clip0_1_37017)">
          <path
            d="M9.16634 15.8333V10.8333H8.19134L9.99967 9.025L11.808 10.8333H10.833V15.8333H9.16634ZM7.49967 17.5H12.4997V12.5H15.833L9.99967 6.66667L4.16634 12.5L7.49967 12.5V17.5ZM4.16634 5L15.833 5V3.33333L4.16634 3.33333V5Z"
            fill="#333232"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_37017">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="matrix(-1 0 0 -1 20 20)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    downloadIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <g clip-path="url(#clip0_1_36910)">
          <path
            d="M12.6663 6.5H9.99967V2.5H5.99967V6.5H3.33301L7.99967 11.1667L12.6663 6.5ZM7.33301 7.83333V3.83333H8.66634V7.83333H9.44634L7.99967 9.28L6.55301 7.83333H7.33301ZM3.33301 12.5H12.6663V13.8333H3.33301V12.5Z"
            fill="#333232"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_36910">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    freeresponse: (
      <svg
        width="20"
        height="6"
        viewBox="0 0 20 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 1H20" stroke="#302F2F" stroke-width="2" />
        <path d="M0 5H10" stroke="#302F2F" stroke-width="2" />
      </svg>
    ),
    checkboxes: (
      <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1"
          y="1.75"
          width="18"
          height="18.5"
          rx="1"
          stroke="#302F2F"
          stroke-width="2"
        />
        <path
          d="M4.71045 10.8553L7.76308 14.25L15.2894 7.75"
          stroke="#302F2F"
          stroke-width="2"
        />
      </svg>
    ),
    dropdown: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1"
          y="1"
          width="18"
          height="18"
          rx="9"
          stroke="#302F2F"
          stroke-width="2"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.0002 7.60017C15.0002 7.75378 14.9458 7.90738 14.8375 8.02438L10.393 12.8245C10.1758 13.0592 9.82464 13.0592 9.60741 12.8245L5.16292 8.02438C4.94569 7.78978 4.94569 7.41056 5.16292 7.17596C5.38014 6.94135 5.73126 6.94135 5.94848 7.17596L10.0002 11.5519L14.0519 7.17596C14.2691 6.94135 14.6202 6.94135 14.8375 7.17596C14.9458 7.29296 15.0002 7.44656 15.0002 7.60017Z"
          fill="#333232"
        />
      </svg>
    ),
    delete: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="18"
        viewBox="0 0 16 18"
        fill="none"
      >
        <path
          d="M14.1041 6.89014C14.1041 6.89014 13.6516 12.5026 13.3891 14.8668C13.2641 15.996 12.5666 16.6576 11.4241 16.6785C9.24993 16.7176 7.07326 16.7201 4.89993 16.6743C3.80076 16.6518 3.11493 15.9818 2.99243 14.8726C2.72826 12.4876 2.27826 6.89014 2.27826 6.89014"
          stroke="#333232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.2569 4.19963H1.12518"
          stroke="#333232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5339 4.19974C11.8797 4.19974 11.3164 3.73724 11.188 3.0964L10.9855 2.08307C10.8605 1.61557 10.4372 1.29224 9.95469 1.29224H6.42719C5.94469 1.29224 5.52136 1.61557 5.39636 2.08307L5.19386 3.0964C5.06552 3.73724 4.50219 4.19974 3.84802 4.19974"
          stroke="#333232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    charts: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M6.14286 8.50146V14.2182"
          stroke="#333232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.0318 5.76611V14.2184"
          stroke="#333232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.8572 11.5225V14.2183"
          stroke="#333232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.9048 1.66675H6.09526C3.37304 1.66675 1.66669 3.59348 1.66669 6.32105V13.6791C1.66669 16.4067 3.3651 18.3334 6.09526 18.3334H13.9048C16.6349 18.3334 18.3334 16.4067 18.3334 13.6791V6.32105C18.3334 3.59348 16.6349 1.66675 13.9048 1.66675Z"
          stroke="#333232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    "tick-square": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.612 1.29175H5.38783C2.87033 1.29175 1.29199 3.07425 1.29199 5.59675V12.4034C1.29199 14.9259 2.86283 16.7084 5.38783 16.7084H12.6112C15.137 16.7084 16.7087 14.9259 16.7087 12.4034V5.59675C16.7087 3.07425 15.137 1.29175 12.612 1.29175Z"
          stroke="#333232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.03326 8.99996L8.0116 10.9775L11.9666 7.02246"
          stroke="#333232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    pendingIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0003 1.66675C14.6027 1.66675 18.3337 5.39771 18.3337 10.0001C18.3337 14.6025 14.6027 18.3334 10.0003 18.3334C5.39795 18.3334 1.66699 14.6025 1.66699 10.0001C1.66699 5.39771 5.39795 1.66675 10.0003 1.66675ZM10.0003 3.33341C6.31843 3.33341 3.33366 6.31818 3.33366 10.0001C3.33366 13.682 6.31843 16.6667 10.0003 16.6667C13.6822 16.6667 16.667 13.682 16.667 10.0001C16.667 6.31818 13.6822 3.33341 10.0003 3.33341ZM10.0003 5.00008C10.4277 5.00008 10.7799 5.32178 10.8281 5.73623L10.8337 5.83341V9.6549L12.2562 11.0775C12.5817 11.4029 12.5817 11.9306 12.2562 12.256C11.9558 12.5564 11.4832 12.5795 11.1562 12.3253L11.0777 12.256L9.41107 10.5893C9.28084 10.4591 9.19816 10.2902 9.17422 10.1096L9.16699 10.0001V5.83341C9.16699 5.37318 9.54009 5.00008 10.0003 5.00008Z"
          fill="#302F2F"
        />
      </svg>
    ),
    darkViewIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0003 3.33325C12.9902 3.33325 15.6298 5.36026 17.9264 9.28618L18.098 9.58418L18.3337 9.99992L17.9264 10.7137C15.6298 14.6396 12.9902 16.6666 10.0003 16.6666C7.01045 16.6666 4.37086 14.6396 2.07428 10.7137L1.90268 10.4157L1.66699 9.99992L1.90268 9.58418C4.23909 5.46288 6.9357 3.33325 10.0003 3.33325ZM10.0003 4.99992C7.74776 4.99992 5.60723 6.5962 3.58809 9.99992C5.60723 13.4036 7.74776 14.9999 10.0003 14.9999C12.1917 14.9999 14.2744 13.4916 16.2395 10.2872L16.4126 10L16.2393 9.7127C14.2711 6.50632 12.1886 4.99992 10.0003 4.99992ZM10.0003 7.49992C11.381 7.49992 12.5003 8.61921 12.5003 9.99992C12.5003 11.3806 11.381 12.4999 10.0003 12.4999C8.61961 12.4999 7.50033 11.3806 7.50033 9.99992C7.50033 8.61921 8.61961 7.49992 10.0003 7.49992Z"
          fill="#302F2F"
        />
      </svg>
    ),
    "interview-icon": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
      >
        <path
          d="M14.9062 7.08142C16.0688 6.91809 16.9638 5.92142 16.9663 4.71392C16.9663 3.52392 16.0988 2.53725 14.9613 2.35059"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.4404 9.87598C17.5663 10.0443 18.3521 10.4385 18.3521 11.251C18.3521 11.8101 17.9821 12.1735 17.3838 12.4018"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.90529 10.2207C7.22695 10.2207 4.93945 10.6265 4.93945 12.2474C4.93945 13.8674 7.21279 14.2849 9.90529 14.2849C12.5836 14.2849 14.8703 13.8832 14.8703 12.2615C14.8703 10.6399 12.5978 10.2207 9.90529 10.2207Z"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.90518 7.90699C11.6627 7.90699 13.0877 6.48283 13.0877 4.72449C13.0877 2.96699 11.6627 1.54199 9.90518 1.54199C8.14768 1.54199 6.72268 2.96699 6.72268 4.72449C6.71601 6.47616 8.13018 7.90116 9.88185 7.90699H9.90518Z"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.90375 7.08142C3.74042 6.91809 2.84625 5.92142 2.84375 4.71392C2.84375 3.52392 3.71125 2.53725 4.84875 2.35059"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.36967 9.87598C2.24384 10.0443 1.45801 10.4385 1.45801 11.251C1.45801 11.8101 1.82801 12.1735 2.42634 12.4018"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    "calander-icon": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
      >
        <path
          d="M1.57715 7.83737H16.4304"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.7015 11.0913H12.7092"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.00421 11.0913H9.01193"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.29816 11.0913H5.30588"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.7015 14.3305H12.7092"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.00421 14.3305H9.01193"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.29816 14.3305H5.30588"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.3694 1.66699V4.40931"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.63795 1.66699V4.40931"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5319 2.9834H5.4758C3.02856 2.9834 1.5 4.34668 1.5 6.85259V14.394C1.5 16.9393 3.02856 18.3341 5.4758 18.3341H12.5242C14.9791 18.3341 16.5 16.9629 16.5 14.457V6.85259C16.5077 4.34668 14.9868 2.9834 12.5319 2.9834Z"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    "clock-icon": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.612 1.29199H5.38783C2.87033 1.29199 1.29199 3.07449 1.29199 5.59699V12.4037C1.29199 14.9262 2.86199 16.7087 5.38783 16.7087H12.6112C15.137 16.7087 16.7087 14.9262 16.7087 12.4037V5.59699C16.7087 3.07449 15.137 1.29199 12.612 1.29199Z"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.8258 10.6813L9 8.99549V5.36133"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    "location-icon": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.08366 7.75075C9.08366 6.59969 8.15096 5.66699 7.00075 5.66699C5.84969 5.66699 4.91699 6.59969 4.91699 7.75075C4.91699 8.90096 5.84969 9.83366 7.00075 9.83366C8.15096 9.83366 9.08366 8.90096 9.08366 7.75075Z"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    "link-icon": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.89354 11.1848L5.26247 8.81586C5.58955 8.48878 6.11985 8.48878 6.44693 8.81586C6.75065 9.11958 6.77235 9.59852 6.51202 9.92727L6.44693 10.0003L4.07801 12.3693C3.09677 13.3505 3.09677 14.9414 4.07801 15.9226C5.02421 16.8688 6.5373 16.9026 7.52399 16.024L7.6314 15.9226L10.0003 13.5537C10.3274 13.2266 10.8577 13.2266 11.1848 13.5537C11.4885 13.8574 11.5102 14.3364 11.2499 14.6651L11.1848 14.7382L8.81586 17.1071C7.18046 18.7425 4.52895 18.7425 2.89354 17.1071C1.30118 15.5147 1.25927 12.959 2.76783 11.316L2.89354 11.1848ZM11.1848 2.89354C12.8202 1.25814 15.4717 1.25814 17.1071 2.89354C18.7425 4.52895 18.7425 7.18046 17.1071 8.81586L14.7382 11.1848C14.4111 11.5119 13.8808 11.5119 13.5537 11.1848C13.2266 10.8577 13.2266 10.3274 13.5537 10.0003L15.9226 7.6314C16.9039 6.65016 16.9039 5.05925 15.9226 4.07801C14.9414 3.09677 13.3505 3.09677 12.3693 4.07801L10.0003 6.44693C9.67324 6.77402 9.14294 6.77402 8.81586 6.44693C8.48878 6.11985 8.48878 5.58955 8.81586 5.26247L11.1848 2.89354ZM11.1848 7.6314C11.5119 7.30432 12.0422 7.30432 12.3693 7.6314C12.6963 7.95848 12.6963 8.48878 12.3693 8.81586L8.81586 12.3693C8.48878 12.6963 7.95848 12.6963 7.6314 12.3693C7.30432 12.0422 7.30432 11.5119 7.6314 11.1848L11.1848 7.6314Z"
          fill="#B1ADAD"
        />
      </svg>
    ),
    "comments-icon": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.8337 1.66699C17.1628 1.66699 18.2532 2.70997 18.3294 4.02034L18.3337 4.16699V12.5003C18.3337 13.8294 17.2907 14.9199 15.9803 14.9961L15.8337 15.0003H12.917L10.667 18.0003C10.5095 18.2103 10.2628 18.3337 10.0003 18.3337C9.77064 18.3337 9.55307 18.2392 9.39676 18.0749L9.33366 18.0003L7.08366 15.0003H4.16699C2.83789 15.0003 1.74744 13.9573 1.67124 12.647L1.66699 12.5003V4.16699C1.66699 2.83789 2.70997 1.74744 4.02034 1.67124L4.16699 1.66699H15.8337ZM15.8337 3.33366H4.16699C3.74062 3.33366 3.38754 3.65628 3.33928 4.07001L3.33366 4.16699V12.5003C3.33366 12.9267 3.65628 13.2798 4.07001 13.328L4.16699 13.3337H7.50033C7.73001 13.3337 7.94758 13.4281 8.10389 13.5924L8.16699 13.667L10.0003 16.1112L11.8337 13.667C11.9715 13.4832 12.1776 13.3658 12.4028 13.3394L12.5003 13.3337H15.8337C16.26 13.3337 16.6131 13.011 16.6614 12.5973L16.667 12.5003V4.16699C16.667 3.74062 16.3444 3.38754 15.9306 3.33928L15.8337 3.33366ZM14.167 9.16699C14.627 9.16699 15.0003 9.54033 15.0003 10.0003C15.0003 10.4275 14.6784 10.7799 14.2641 10.828L14.167 10.8337H5.83366C5.37366 10.8337 5.00033 10.4603 5.00033 10.0003C5.00033 9.57318 5.32223 9.22077 5.73652 9.1726L5.83366 9.16699H14.167ZM14.167 5.83366C14.627 5.83366 15.0003 6.20699 15.0003 6.66699C15.0003 7.09414 14.6784 7.44655 14.2641 7.49472L14.167 7.50033H5.83366C5.37366 7.50033 5.00033 7.12699 5.00033 6.66699C5.00033 6.23985 5.32223 5.88743 5.73652 5.83927L5.83366 5.83366H14.167Z"
          fill="#B1ADAD"
        />
      </svg>
    ),
    "message-icon": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.95931 14.0003L2.0209 17.1511C1.47527 17.5876 0.666992 17.1991 0.666992 16.5003V3.16699C0.666992 1.78628 1.78628 0.666992 3.16699 0.666992H14.8337C16.2144 0.666992 17.3337 1.78628 17.3337 3.16699V11.5003C17.3337 12.881 16.2144 14.0003 14.8337 14.0003H5.95931ZM2.33366 14.7665L5.14641 12.5163C5.29417 12.3981 5.47777 12.3337 5.66699 12.3337H14.8337C15.2939 12.3337 15.667 11.9606 15.667 11.5003V3.16699C15.667 2.70675 15.2939 2.33366 14.8337 2.33366H3.16699C2.70675 2.33366 2.33366 2.70675 2.33366 3.16699V14.7665Z"
          fill="#4F449B"
        />
      </svg>
    ),
    export: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.16675 1.6665H5.83342C6.29365 1.6665 6.66675 2.0396 6.66675 2.49984C6.66675 2.9272 6.34505 3.27943 5.9306 3.32756L5.83342 3.33317H4.16675C3.73938 3.33317 3.38716 3.65487 3.33902 4.06932L3.33341 4.1665V15.8332C3.33341 16.2605 3.65512 16.6128 4.06956 16.6609L4.16675 16.6665H15.8334C16.2608 16.6665 16.613 16.3448 16.6611 15.9304L16.6667 15.8332V14.1665C16.6667 13.7063 17.0398 13.3332 17.5001 13.3332C17.9274 13.3332 18.2797 13.6549 18.3278 14.0693L18.3334 14.1665V15.8332C18.3334 17.1646 17.2926 18.2529 15.9803 18.3289L15.8334 18.3332H4.16675C2.83535 18.3332 1.74703 17.2924 1.67099 15.9801L1.66675 15.8332V4.1665C1.66675 2.8351 2.70751 1.74679 4.01985 1.67075L4.16675 1.6665H5.83342H4.16675ZM17.5001 1.6665L17.5676 1.669L17.6674 1.68337L17.7602 1.70795L17.8528 1.74457L17.934 1.78817L18.014 1.84383L18.0893 1.91058L18.1698 2.00375L18.2295 2.09645L18.2554 2.14725L18.2835 2.21513L18.3035 2.27818L18.3277 2.40142L18.3334 2.49984V7.49984C18.3334 7.96007 17.9603 8.33317 17.5001 8.33317C17.0398 8.33317 16.6667 7.96007 16.6667 7.49984V4.5115L11.4227 9.75576C11.1223 10.0562 10.6496 10.0793 10.3227 9.82508L10.2442 9.75576C9.94376 9.45536 9.92065 8.98266 10.1748 8.65575L10.2442 8.57725L15.4867 3.33317H12.5001C12.0398 3.33317 11.6667 2.96007 11.6667 2.49984C11.6667 2.0396 12.0398 1.6665 12.5001 1.6665H17.5001Z"
          fill="#302F2F"
        />
      </svg>
    ),

    "export-2": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <g clip-path="url(#clip0_1_37017)">
          <path
            d="M9.16634 15.8333V10.8333H8.19134L9.99967 9.025L11.808 10.8333H10.833V15.8333H9.16634ZM7.49967 17.5H12.4997V12.5H15.833L9.99967 6.66667L4.16634 12.5L7.49967 12.5V17.5ZM4.16634 5L15.833 5V3.33333L4.16634 3.33333V5Z"
            fill="#333232"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_37017">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="matrix(-1 0 0 -1 20 20)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    "unaccepted-meetings": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="32"
          height="32"
          rx="16"
          fill="#44449B"
          fill-opacity="0.1"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.3406 16.1203L22.2555 11.5835C22.6186 11.2483 22.6186 10.7066 22.2555 10.3715C21.8925 10.0363 21.3056 10.0363 20.9425 10.3715L16.0276 14.9083L11.1127 10.3715C10.7496 10.0363 10.1627 10.0363 9.79965 10.3715C9.43658 10.7066 9.43658 11.2483 9.79965 11.5835L14.7146 16.1203L9.79965 20.6572C9.43658 20.9924 9.43658 21.5341 9.79965 21.8692C9.98072 22.0364 10.2184 22.1204 10.4561 22.1204C10.6939 22.1204 10.9316 22.0364 11.1127 21.8692L16.0276 17.3324L20.9425 21.8692C21.1236 22.0364 21.3613 22.1204 21.599 22.1204C21.8368 22.1204 22.0745 22.0364 22.2555 21.8692C22.6186 21.5341 22.6186 20.9924 22.2555 20.6572L17.3406 16.1203Z"
          fill="#44449B"
        />
      </svg>
    ),
    "completed-meetings": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="32"
          height="32"
          rx="16"
          fill="#44449B"
          fill-opacity="0.1"
        />
        <path
          d="M7.45557 15.7662L12.3867 21.25L24.5446 10.75"
          stroke="#44449B"
          stroke-width="2"
        />
      </svg>
    ),
    "new-meetings": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="32"
          height="32"
          rx="16"
          fill="#44449B"
          fill-opacity="0.1"
        />
        <g clip-path="url(#clip0_1_25484)">
          <path
            d="M21.1585 16.3668L18.4585 15.0168C19.5335 14.1835 20.2252 12.8835 20.2252 11.4168C20.2252 8.89183 18.1668 6.8335 15.6418 6.8335C13.1168 6.8335 11.0585 8.89183 11.0585 11.4168C11.0585 13.1918 12.0752 14.7335 13.5585 15.4918V18.2085C11.7668 17.8252 11.8752 17.8418 11.6752 17.8418C11.2335 17.8418 10.8168 18.0168 10.5002 18.3335L9.3335 19.5168L13.5752 23.7585C13.9335 24.1252 14.4335 24.3335 14.9502 24.3335H20.2002C21.0168 24.3335 21.7085 23.7502 21.8418 22.9418L22.5085 19.0168C22.6918 17.9335 22.1502 16.8668 21.1585 16.3668ZM20.8668 18.7418L20.2002 22.6668H14.9502C14.8752 22.6668 14.8085 22.6335 14.7502 22.5835L11.6835 19.5168L15.2252 20.2585V11.4168C15.2252 11.1835 15.4085 11.0002 15.6418 11.0002C15.8752 11.0002 16.0585 11.1835 16.0585 11.4168V16.4168H17.5252L20.4085 17.8585C20.7418 18.0252 20.9252 18.3835 20.8668 18.7418ZM12.7252 11.4168C12.7252 9.8085 14.0335 8.50016 15.6418 8.50016C17.2502 8.50016 18.5585 9.8085 18.5585 11.4168C18.5585 12.2085 18.2418 12.9252 17.7252 13.4502V11.4168C17.7252 10.2668 16.7918 9.3335 15.6418 9.3335C14.4918 9.3335 13.5585 10.2668 13.5585 11.4168V13.4502C13.0418 12.9252 12.7252 12.2085 12.7252 11.4168Z"
            fill="#44449B"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_25484">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(6 6)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    "dropdown-dots": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 17C13.1046 17 14 17.8954 14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19C10 17.8954 10.8954 17 12 17ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM12 3C13.1046 3 14 3.89543 14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5C10 3.89543 10.8954 3 12 3Z"
          fill="#DADADE"
        />
      </svg>
    ),
    person: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.83329 13.3332H14.1666C16.4678 13.3332 18.3333 15.1987 18.3333 17.4998C18.3333 17.9601 17.9602 18.3332 17.5 18.3332C17.0726 18.3332 16.7204 18.0115 16.6722 17.597L16.6624 17.3529C16.5892 16.0892 15.5773 15.0773 14.3135 15.0041L14.1666 14.9998H5.83329C4.45258 14.9998 3.33329 16.1191 3.33329 17.4998C3.33329 17.9601 2.9602 18.3332 2.49996 18.3332C2.03972 18.3332 1.66663 17.9601 1.66663 17.4998C1.66663 15.2592 3.43521 13.4317 5.65255 13.337L5.83329 13.3332H14.1666H5.83329ZM9.99996 1.6665C12.7614 1.6665 15 3.90508 15 6.6665C15 9.42793 12.7614 11.6665 9.99996 11.6665C7.23854 11.6665 4.99996 9.42793 4.99996 6.6665C4.99996 3.90508 7.23854 1.6665 9.99996 1.6665ZM9.99996 3.33317C8.15901 3.33317 6.66663 4.82555 6.66663 6.6665C6.66663 8.50745 8.15901 9.99984 9.99996 9.99984C11.8409 9.99984 13.3333 8.50745 13.3333 6.6665C13.3333 4.82555 11.8409 3.33317 9.99996 3.33317Z"
          fill="#A6A6A6"
        />
      </svg>
    ),
    location: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.08329 7.75026C9.08329 6.5992 8.1506 5.6665 7.00038 5.6665C5.84932 5.6665 4.91663 6.5992 4.91663 7.75026C4.91663 8.90047 5.84932 9.83317 7.00038 9.83317C8.1506 9.83317 9.08329 8.90047 9.08329 7.75026Z"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    link: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.89318 11.1843L5.26211 8.81537C5.58919 8.48829 6.11949 8.48829 6.44657 8.81537C6.75029 9.11909 6.77198 9.59804 6.51165 9.92679L6.44657 9.99984L4.07764 12.3688C3.0964 13.35 3.0964 14.9409 4.07764 15.9222C5.02384 16.8684 6.53693 16.9021 7.52362 16.0235L7.63103 15.9222L9.99996 13.5532C10.327 13.2261 10.8573 13.2261 11.1844 13.5532C11.4881 13.8569 11.5098 14.3359 11.2495 14.6646L11.1844 14.7377L8.8155 17.1066C7.18009 18.742 4.52858 18.742 2.89318 17.1066C1.30081 15.5143 1.25891 12.9586 2.76746 11.3155L2.89318 11.1843ZM11.1844 2.89306C12.8198 1.25765 15.4713 1.25765 17.1067 2.89306C18.7421 4.52846 18.7421 7.17997 17.1067 8.81537L14.7378 11.1843C14.4107 11.5114 13.8804 11.5114 13.5534 11.1843C13.2263 10.8572 13.2263 10.3269 13.5534 9.99984L15.9223 7.63091C16.9035 6.64967 16.9035 5.05876 15.9223 4.07752C14.941 3.09628 13.3501 3.09628 12.3689 4.07752L9.99996 6.44645C9.67288 6.77353 9.14258 6.77353 8.8155 6.44645C8.48841 6.11937 8.48841 5.58906 8.8155 5.26198L11.1844 2.89306ZM11.1844 7.63091C11.5115 7.30383 12.0418 7.30383 12.3689 7.63091C12.696 7.95799 12.696 8.48829 12.3689 8.81537L8.8155 12.3688C8.48842 12.6958 7.95811 12.6958 7.63103 12.3688C7.30395 12.0417 7.30395 11.5114 7.63103 11.1843L11.1844 7.63091Z"
          fill="#B1ADAD"
        />
      </svg>
    ),
    accept: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.32806 14.1219L3.36569 9.46971C3.05327 9.17682 2.54673 9.17682 2.23431 9.46971C1.9219 9.7626 1.9219 10.2375 2.23431 10.5304L7.83432 15.7804C8.17346 16.0983 8.73274 16.067 9.02906 15.7134L17.8291 5.2134C18.102 4.8877 18.0417 4.4162 17.6943 4.16029C17.3468 3.90438 16.8439 3.96096 16.571 4.28667L8.32806 14.1219Z"
          fill="#B1ADAD"
        />
      </svg>
    ),
    "meeting-schedule": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
      >
        <path
          d="M1.57715 7.83688H16.4304"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.7017 11.0913H12.7094"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.00384 11.0913H9.01156"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.29828 11.0913H5.306"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.7017 14.33H12.7094"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.00384 14.33H9.01156"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.29828 14.33H5.306"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.3698 1.6665V4.40882"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.63795 1.6665V4.40882"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5319 2.98242H5.4758C3.02856 2.98242 1.5 4.3457 1.5 6.85161V14.393C1.5 16.9383 3.02856 18.3331 5.4758 18.3331H12.5242C14.9791 18.3331 16.5 16.9619 16.5 14.456V6.85161C16.5077 4.3457 14.9868 2.98242 12.5319 2.98242Z"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    "additional-info": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.8333 1.6665C17.1624 1.6665 18.2528 2.70948 18.329 4.01985L18.3333 4.1665V12.4998C18.3333 13.8289 17.2903 14.9194 15.98 14.9956L15.8333 14.9998H12.9166L10.6666 17.9998C10.5091 18.2098 10.2625 18.3332 9.99996 18.3332C9.77027 18.3332 9.55271 18.2387 9.39639 18.0745L9.33329 17.9998L7.08329 14.9998H4.16663C2.83752 14.9998 1.74707 13.9569 1.67088 12.6465L1.66663 12.4998V4.1665C1.66663 2.8374 2.7096 1.74695 4.01997 1.67076L4.16663 1.6665H15.8333ZM15.8333 3.33317H4.16663C3.74026 3.33317 3.38718 3.65579 3.33891 4.06952L3.33329 4.1665V12.4998C3.33329 12.9262 3.65592 13.2793 4.06964 13.3275L4.16663 13.3332H7.49996C7.72965 13.3332 7.94721 13.4276 8.10353 13.5919L8.16663 13.6665L9.99996 16.1107L11.8333 13.6665C11.9711 13.4828 12.1772 13.3654 12.4024 13.3389L12.5 13.3332H15.8333C16.2597 13.3332 16.6127 13.0105 16.661 12.5968L16.6666 12.4998V4.1665C16.6666 3.74013 16.344 3.38706 15.9303 3.33879L15.8333 3.33317ZM14.1666 9.1665C14.6266 9.1665 15 9.53984 15 9.99984C15 10.427 14.6781 10.7794 14.2638 10.8276L14.1666 10.8332H5.83329C5.37329 10.8332 4.99996 10.4598 4.99996 9.99984C4.99996 9.57269 5.32186 9.22028 5.73615 9.17211L5.83329 9.1665H14.1666ZM14.1666 5.83317C14.6266 5.83317 15 6.2065 15 6.6665C15 7.09365 14.6781 7.44606 14.2638 7.49423L14.1666 7.49984H5.83329C5.37329 7.49984 4.99996 7.1265 4.99996 6.6665C4.99996 6.23936 5.32186 5.88695 5.73615 5.83878L5.83329 5.83317H14.1666Z"
          fill="#B1ADAD"
        />
      </svg>
    ),
    "meeting-reason": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
      >
        <path
          d="M14.9064 7.08044C16.0689 6.91711 16.9639 5.92044 16.9664 4.71294C16.9664 3.52294 16.0989 2.53628 14.9614 2.34961"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.4404 9.875C17.5663 10.0433 18.3521 10.4375 18.3521 11.25C18.3521 11.8092 17.9821 12.1725 17.3838 12.4008"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.90553 10.2197C7.2272 10.2197 4.9397 10.6256 4.9397 12.2464C4.9397 13.8664 7.21303 14.2839 9.90553 14.2839C12.5839 14.2839 14.8705 13.8822 14.8705 12.2606C14.8705 10.6389 12.598 10.2197 9.90553 10.2197Z"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.90555 7.9065C11.663 7.9065 13.088 6.48234 13.088 4.724C13.088 2.9665 11.663 1.5415 9.90555 1.5415C8.14805 1.5415 6.72305 2.9665 6.72305 4.724C6.71638 6.47567 8.13055 7.90067 9.88221 7.9065H9.90555Z"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.90399 7.08044C3.74066 6.91711 2.84649 5.92044 2.84399 4.71294C2.84399 3.52294 3.71149 2.53628 4.84899 2.34961"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.36992 9.875C2.24409 10.0433 1.45825 10.4375 1.45825 11.25C1.45825 11.8092 1.82825 12.1725 2.42659 12.4008"
          stroke="#B1ADAD"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    sort: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.19526 10.1954C4.43558 9.9551 4.81374 9.93662 5.07527 10.14L5.13807 10.1954L8 13.0574L10.8619 10.1954C11.1223 9.93508 11.5444 9.93508 11.8047 10.1954C12.0451 10.4357 12.0635 10.8139 11.8602 11.0754L11.8047 11.1382L8.4714 14.4716C8.23108 14.7119 7.85293 14.7304 7.5914 14.527L7.5286 14.4716L4.19526 11.1382C3.93491 10.8779 3.93491 10.4558 4.19526 10.1954ZM8.4714 1.52876L11.8047 4.86209C12.0651 5.12244 12.0651 5.54455 11.8047 5.8049C11.5444 6.06525 11.1223 6.06525 10.8619 5.8049L8 2.94297L5.13807 5.8049C4.87772 6.06525 4.45561 6.06525 4.19526 5.8049C3.93491 5.54455 3.93491 5.12244 4.19526 4.86209L7.5286 1.52876C7.78895 1.26841 8.21105 1.26841 8.4714 1.52876Z"
          fill="#4F449B"
        />
      </svg>
    ),
    "up-arrow": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.29033 9.03224L4.21967 8.96569C3.94931 8.6773 3.92851 8.22351 4.15728 7.90968L4.21967 7.83431L9.46967 2.23431L9.50264 2.2012L9.55352 2.15707L9.63695 2.09974L9.7215 2.05698L9.80051 2.02868L9.91143 2.00553L10 2L10.0564 2.00223L10.1505 2.01619L10.2341 2.03979L10.3174 2.07494L10.3905 2.1168L10.4691 2.17575L10.5303 2.23431L15.7803 7.83431C16.0732 8.14673 16.0732 8.65327 15.7803 8.96569C15.51 9.25407 15.0845 9.27626 14.7903 9.03224L14.7197 8.96569L10.75 4.7328V17.2C10.75 17.6418 10.4142 18 10 18C9.58579 18 9.25 17.6418 9.25 17.2V4.7312L5.28033 8.96569C5.00997 9.25407 4.58454 9.27626 4.29033 9.03224L4.21967 8.96569L4.29033 9.03224Z"
          fill="#757575"
        />
      </svg>
    ),
    "down-arrow": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.7097 10.9678L15.7803 11.0343C16.0507 11.3227 16.0715 11.7765 15.8427 12.0903L15.7803 12.1657L10.5303 17.7657L10.4974 17.7988L10.4465 17.8429L10.363 17.9003L10.2785 17.943L10.1995 17.9713L10.0886 17.9945L10 18L9.94357 17.9978L9.84946 17.9838L9.76589 17.9602L9.68258 17.9251L9.60947 17.8832L9.53091 17.8242L9.46967 17.7657L4.21967 12.1657C3.92678 11.8533 3.92678 11.3467 4.21967 11.0343C4.49003 10.7459 4.91546 10.7237 5.20967 10.9678L5.28033 11.0343L9.25 15.2672V2.8C9.25 2.35817 9.58579 2 10 2C10.4142 2 10.75 2.35817 10.75 2.8V15.2688L14.7197 11.0343C14.99 10.7459 15.4155 10.7237 15.7097 10.9678L15.7803 11.0343L15.7097 10.9678Z"
          fill="#757575"
        />
      </svg>
    ),
    group: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H18C19.1 18 20 17.1 20 16V2C20 0.9 19.1 0 18 0ZM18 16H2V2H18V16Z"
          fill="#44449B"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.41 7.42L15.99 6L12.82 9.17L11.41 7.75L10 9.16L12.82 12L17.41 7.42Z"
          fill="#44449B"
        />
        <path d="M8 4H3V6H8V4Z" fill="#44449B" />
        <path d="M8 8H3V10H8V8Z" fill="#44449B" />
        <path d="M8 12H3V14H8V12Z" fill="#44449B" />
      </svg>
    ),
    program: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.4998 15.0002C17.9601 15.0002 18.3332 15.3733 18.3332 15.8335C18.3332 16.2937 17.9601 16.6668 17.4998 16.6668H5.83317C5.37293 16.6668 4.99984 16.2937 4.99984 15.8335C4.99984 15.3733 5.37293 15.0002 5.83317 15.0002H17.4998ZM17.4998 9.16683C17.9601 9.16683 18.3332 9.53993 18.3332 10.0002C18.3332 10.4604 17.9601 10.8335 17.4998 10.8335H5.83317C5.37293 10.8335 4.99984 10.4604 4.99984 10.0002C4.99984 9.53993 5.37293 9.16683 5.83317 9.16683H17.4998ZM17.4998 3.3335C17.9601 3.3335 18.3332 3.70659 18.3332 4.16683C18.3332 4.62707 17.9601 5.00016 17.4998 5.00016H5.83317C5.37293 5.00016 4.99984 4.62707 4.99984 4.16683C4.99984 3.70659 5.37293 3.3335 5.83317 3.3335H17.4998ZM1.6665 3.3335H3.33317V5.00016H1.6665V3.3335ZM1.6665 9.16683H3.33317V10.8335H1.6665V9.16683ZM1.6665 15.0002H3.33317V16.6668H1.6665V15.0002Z"
          fill="#B1ADAD"
        />
      </svg>
    ),
    followLink: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.16675 1.66663H5.83342C6.29365 1.66663 6.66675 2.03972 6.66675 2.49996C6.66675 2.92732 6.34505 3.27955 5.9306 3.32769L5.83342 3.33329H4.16675C3.73938 3.33329 3.38716 3.65499 3.33902 4.06944L3.33341 4.16663V15.8333C3.33341 16.2607 3.65512 16.6129 4.06956 16.661L4.16675 16.6666H15.8334C16.2608 16.6666 16.613 16.3449 16.6611 15.9305L16.6667 15.8333V14.1666C16.6667 13.7064 17.0398 13.3333 17.5001 13.3333C17.9274 13.3333 18.2797 13.655 18.3278 14.0694L18.3334 14.1666V15.8333C18.3334 17.1647 17.2926 18.253 15.9803 18.3291L15.8334 18.3333H4.16675C2.83535 18.3333 1.74703 17.2925 1.67099 15.9802L1.66675 15.8333V4.16663C1.66675 2.83523 2.70751 1.74691 4.01985 1.67087L4.16675 1.66663H5.83342H4.16675ZM17.5001 1.66663L17.5676 1.66913L17.6674 1.68349L17.7602 1.70807L17.8528 1.74469L17.934 1.78829L18.014 1.84395L18.0893 1.9107L18.1698 2.00387L18.2295 2.09657L18.2554 2.14738L18.2835 2.21525L18.3035 2.2783L18.3277 2.40155L18.3334 2.49996V7.49996C18.3334 7.9602 17.9603 8.33329 17.5001 8.33329C17.0398 8.33329 16.6667 7.9602 16.6667 7.49996V4.51163L11.4227 9.75588C11.1223 10.0563 10.6496 10.0794 10.3227 9.82521L10.2442 9.75588C9.94376 9.45548 9.92065 8.98279 10.1748 8.65588L10.2442 8.57737L15.4867 3.33329H12.5001C12.0398 3.33329 11.6667 2.9602 11.6667 2.49996C11.6667 2.03972 12.0398 1.66663 12.5001 1.66663H17.5001Z"
          fill="#396DFA"
        />
      </svg>
    ),
    mentors: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill="none"
      >
        <path
          d="M13.7497 3.64998C14.6701 3.64998 15.4163 2.90379 15.4163 1.98332C15.4163 1.06284 14.6701 0.31665 13.7497 0.31665C12.8292 0.31665 12.083 1.06284 12.083 1.98332C12.083 2.90379 12.8292 3.64998 13.7497 3.64998Z"
          fill="#44449B"
        />
        <path
          d="M19.9999 9.89999V5.98332L15.7915 4.19999C14.9832 3.85832 14.0499 4.14999 13.5832 4.89999L12.7499 6.23332C12.1915 7.21665 11.1582 7.94999 9.9082 8.16665L9.9582 8.21665C10.5332 8.79165 11.2249 9.10832 12.0082 9.19165C12.6749 8.84165 13.2749 8.37499 13.7499 7.82499L14.2499 10.325L13.2832 11.2417L12.4999 11.9833V12.6167V18.2333H14.1665V13.2333L15.9165 11.5667L17.4165 18.2333H19.1665L17.3499 9.06665L16.8332 6.48332L18.3332 7.06665V9.89999H19.9999Z"
          fill="#44449B"
        />
        <path
          d="M8.57473 6.74159C8.75806 6.86659 8.96639 6.94159 9.17473 6.98326C9.28306 6.99993 9.38306 7.01659 9.49139 7.01659C9.59973 7.01659 9.70806 7.00826 9.80806 6.98326C9.91639 6.96659 10.0164 6.93326 10.1164 6.89159C10.3164 6.80826 10.5081 6.69159 10.6664 6.52493C11.0747 6.11659 11.2247 5.54993 11.1247 5.02493C11.0664 4.71659 10.9164 4.40826 10.6664 4.16659C10.5081 4.00826 10.3164 3.88326 10.1164 3.79993C10.0164 3.75826 9.91639 3.72493 9.80806 3.70826C9.69973 3.69159 9.59973 3.67493 9.49139 3.67493C9.39139 3.67493 9.29972 3.68326 9.19973 3.69993C9.08306 3.71659 8.96639 3.74993 8.85806 3.79159C8.66639 3.88326 8.47472 4.00826 8.31639 4.16659C8.06639 4.40826 7.91639 4.71659 7.85806 5.02493C7.75806 5.54993 7.90806 6.11659 8.31639 6.52493C8.39139 6.60826 8.48306 6.67493 8.57473 6.74159Z"
          fill="#44449B"
        />
        <path
          d="M9.3665 8.80002L7.69984 7.13336C7.6165 7.05002 7.53317 6.98336 7.4415 6.91669C7.25817 6.80002 7.04984 6.71669 6.8415 6.68336C6.73317 6.65836 6.63317 6.65002 6.52484 6.65002C6.09984 6.65002 5.67484 6.81669 5.34984 7.14169L2.5665 9.92502C2.22484 10.2667 2.04984 10.7417 2.08317 11.2084C2.08317 11.3584 2.1165 11.5167 2.17484 11.6667L3.0665 14.125L0.0415039 17.15L1.2165 18.3334L4.74984 14.8V12.95L5.83317 13.9584V18.2334H7.49984V13.2334L5.73317 11.4667L7.69984 9.50002L8.2915 10.0917C9.3665 11.1417 10.7665 11.7917 12.4832 11.7917L12.3665 10.0667C11.1165 10.05 10.1165 9.55002 9.3665 8.80002Z"
          fill="#44449B"
        />
      </svg>
    ),
    groups: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="10"
        viewBox="0 0 20 10"
        fill="none"
      >
        <path
          d="M3.33333 5.83333C4.25 5.83333 5 5.08333 5 4.16667C5 3.25 4.25 2.5 3.33333 2.5C2.41667 2.5 1.66667 3.25 1.66667 4.16667C1.66667 5.08333 2.41667 5.83333 3.33333 5.83333ZM4.275 6.75C3.96667 6.7 3.65833 6.66667 3.33333 6.66667C2.50833 6.66667 1.725 6.84167 1.01667 7.15C0.4 7.41667 0 8.01667 0 8.69167V10H3.75V8.65833C3.75 7.96667 3.94167 7.31667 4.275 6.75ZM16.6667 5.83333C17.5833 5.83333 18.3333 5.08333 18.3333 4.16667C18.3333 3.25 17.5833 2.5 16.6667 2.5C15.75 2.5 15 3.25 15 4.16667C15 5.08333 15.75 5.83333 16.6667 5.83333ZM20 8.69167C20 8.01667 19.6 7.41667 18.9833 7.15C18.275 6.84167 17.4917 6.66667 16.6667 6.66667C16.3417 6.66667 16.0333 6.7 15.725 6.75C16.0583 7.31667 16.25 7.96667 16.25 8.65833V10H20V8.69167ZM13.5333 6.375C12.5583 5.94167 11.3583 5.625 10 5.625C8.64167 5.625 7.44167 5.95 6.46667 6.375C5.56667 6.775 5 7.675 5 8.65833V10H15V8.65833C15 7.675 14.4333 6.775 13.5333 6.375ZM6.725 8.33333C6.8 8.14167 6.83333 8.00833 7.48333 7.75833C8.29167 7.44167 9.14167 7.29167 10 7.29167C10.8583 7.29167 11.7083 7.44167 12.5167 7.75833C13.1583 8.00833 13.1917 8.14167 13.275 8.33333H6.725ZM10 1.66667C10.4583 1.66667 10.8333 2.04167 10.8333 2.5C10.8333 2.95833 10.4583 3.33333 10 3.33333C9.54167 3.33333 9.16667 2.95833 9.16667 2.5C9.16667 2.04167 9.54167 1.66667 10 1.66667ZM10 0C8.61667 0 7.5 1.11667 7.5 2.5C7.5 3.88333 8.61667 5 10 5C11.3833 5 12.5 3.88333 12.5 2.5C12.5 1.11667 11.3833 0 10 0Z"
          fill="#44449B"
        />
      </svg>
    ),
    groupAdd: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clip-path="url(#clip0_1_526)">
          <path
            d="M5 15V12H8V10H5V7H3V10H0V12H3V15H5ZM12 13.75C9.66 13.75 5 14.92 5 17.25V19H19V17.25C19 14.92 14.34 13.75 12 13.75ZM7.34 17C8.18 16.42 10.21 15.75 12 15.75C13.79 15.75 15.82 16.42 16.66 17H7.34ZM12 12C13.93 12 15.5 10.43 15.5 8.5C15.5 6.57 13.93 5 12 5C10.07 5 8.5 6.57 8.5 8.5C8.5 10.43 10.07 12 12 12ZM12 7C12.83 7 13.5 7.67 13.5 8.5C13.5 9.33 12.83 10 12 10C11.17 10 10.5 9.33 10.5 8.5C10.5 7.67 11.17 7 12 7ZM17 12C18.93 12 20.5 10.43 20.5 8.5C20.5 6.57 18.93 5 17 5C16.76 5 16.52 5.02 16.29 5.07C17.05 6.01 17.5 7.2 17.5 8.5C17.5 9.8 17.03 10.98 16.27 11.92C16.51 11.97 16.75 12 17 12ZM19.32 14.02C20.32 14.83 21 15.89 21 17.25V19H24V17.25C24 15.56 21.56 14.49 19.32 14.02Z"
            fill="#44449B"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_526">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    event: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clip-path="url(#clip0_1_533)">
          <path
            d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM12 13H17V18H12V13Z"
            fill="#44449B"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_533">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    "star-empty": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        width={size}
        height={size}
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    ),
    "star-filled": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="yellow"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        width={size}
        height={size}
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    ),
    "magic-wand": (
      <svg
        width={size}
        height={size}
        viewBox="0 0 28 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.2459 1.41208L24.1871 1.86017C24.1737 1.96215 24.2055 2.06489 24.2742 2.14143L24.5761 2.47776C24.6706 2.58305 24.5831 2.7491 24.4428 2.73068L23.9947 2.67187C23.8928 2.65848 23.79 2.69032 23.7135 2.75902L23.3771 3.06089C23.2718 3.1554 23.1058 3.06792 23.1242 2.92763L23.183 2.47955C23.1964 2.37756 23.1646 2.27483 23.0959 2.19828L22.794 1.86196C22.6995 1.75666 22.787 1.59061 22.9273 1.60903L23.3754 1.66784C23.4773 1.68123 23.5801 1.64939 23.6566 1.58069L23.9929 1.27882C24.0982 1.18431 24.2643 1.2718 24.2459 1.41208Z"
          stroke="#FFBA24"
          stroke-width="0.2"
        />
        <path
          d="M20.7102 3.09953L20.6159 3.8175C20.5911 4.00688 20.6502 4.19767 20.7778 4.33981L21.2614 4.8787C21.3572 4.9854 21.2686 5.15366 21.1264 5.135L20.4084 5.04076C20.2191 5.0159 20.0283 5.07502 19.8861 5.20261L19.3472 5.68629C19.2405 5.78206 19.0723 5.69341 19.0909 5.55125L19.1852 4.83329C19.21 4.64391 19.1509 4.45312 19.0233 4.31097L18.5396 3.77208C18.4439 3.66538 18.5325 3.49712 18.6747 3.51578L19.3927 3.61002C19.582 3.63488 19.7728 3.57576 19.915 3.44818L20.4539 2.96449C20.5606 2.86872 20.7288 2.95738 20.7102 3.09953Z"
          stroke="#FFBA24"
          stroke-width="0.5"
        />
        <path
          d="M13.3781 6.44256C13.5499 5.97823 14.2067 5.97823 14.3785 6.44256L14.7099 7.33809C14.7639 7.48408 14.879 7.59918 15.025 7.65319L15.9205 7.98457C16.3848 8.15639 16.3848 8.81313 15.9205 8.98495L15.025 9.31633C14.879 9.37034 14.7639 9.48544 14.7099 9.63143L14.3785 10.527C14.2067 10.9913 13.5499 10.9913 13.3781 10.527L13.0467 9.63143C12.9927 9.48544 12.8776 9.37034 12.7316 9.31633L11.8361 8.98495C11.3718 8.81313 11.3718 8.15639 11.8361 7.98457L12.7316 7.65319C12.8776 7.59918 12.9927 7.48408 13.0467 7.33809L13.3781 6.44256Z"
          fill="#FFBA24"
        />
        <path
          d="M24.0477 11.3644C24.198 10.9581 24.7726 10.9581 24.923 11.3644L25.2129 12.148C25.2602 12.2757 25.3609 12.3765 25.4887 12.4237L26.2723 12.7137C26.6785 12.864 26.6785 13.4387 26.2723 13.589L25.4887 13.879C25.3609 13.9262 25.2602 14.0269 25.2129 14.1547L24.923 14.9383C24.7726 15.3446 24.198 15.3446 24.0477 14.9383L23.7577 14.1547C23.7104 14.0269 23.6097 13.9262 23.482 13.879L22.6984 13.589C22.2921 13.4387 22.2921 12.864 22.6984 12.7137L23.482 12.4237C23.6097 12.3765 23.7104 12.2757 23.7577 12.148L24.0477 11.3644Z"
          fill="#FFBA24"
        />
        <path
          d="M24.6252 5.05459L24.8689 5.71316C24.9144 5.83634 25.0116 5.93345 25.1347 5.97903L25.7933 6.22272C25.9239 6.27105 25.9239 6.45575 25.7933 6.50408L25.1347 6.74777C25.0116 6.79335 24.9144 6.89046 24.8689 7.01364L24.6252 7.67221C24.5768 7.8028 24.3921 7.8028 24.3438 7.67221L24.1001 7.01364C24.0545 6.89046 23.9574 6.79335 23.8343 6.74777L23.1757 6.50408C23.0451 6.45575 23.0451 6.27105 23.1757 6.22272L23.8343 5.97903C23.9574 5.93345 24.0545 5.83634 24.1001 5.71316L24.3438 5.05459C24.3921 4.924 24.5768 4.924 24.6252 5.05459Z"
          stroke="#FFBA24"
          stroke-width="0.3"
        />
        <path
          d="M18.4932 11.5068L4.24919 25.7508"
          stroke="#817C7C"
          stroke-width="4"
        />
        <path
          d="M20.7422 9.25781L18.4931 11.5069"
          stroke="#D9D9D9"
          stroke-width="4"
        />
        <path
          d="M4.24902 25.751L1.99997 28"
          stroke="#D9D9D9"
          stroke-width="4"
        />
        <path
          d="M21.2902 14.184C21.3676 13.975 21.6631 13.975 21.7404 14.184L21.9354 14.7108C21.9597 14.7765 22.0115 14.8283 22.0772 14.8526L22.604 15.0476C22.813 15.1249 22.813 15.4204 22.604 15.4977L22.0772 15.6927C22.0115 15.717 21.9597 15.7688 21.9354 15.8345L21.7404 16.3613C21.6631 16.5703 21.3676 16.5703 21.2902 16.3613L21.0953 15.8345C21.071 15.7688 21.0192 15.717 20.9535 15.6927L20.4266 15.4977C20.2177 15.4204 20.2177 15.1249 20.4266 15.0476L20.9535 14.8526C21.0192 14.8283 21.071 14.7765 21.0953 14.7108L21.2902 14.184Z"
          fill="#FFBA24"
        />
      </svg>
    ),
    "arrow-forward": (
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.9585 9.77132H4.4585"
          stroke="#888787"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.917 4.75116L16.9587 9.77116L11.917 14.792"
          stroke="#888787"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    "collabs-left": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.33366 17.4998C3.33366 17.9601 2.96056 18.3332 2.50033 18.3332C2.04009 18.3332 1.66699 17.9601 1.66699 17.4998V2.49984C1.66699 2.0396 2.04009 1.6665 2.50033 1.6665C2.96056 1.6665 3.33366 2.0396 3.33366 2.49984V17.4998ZM5.00033 9.99984L5.00366 9.9315L5.01719 9.83257L5.04177 9.73972L5.07839 9.64715L5.12199 9.56591L5.16392 9.50387L5.2444 9.41058L8.57774 6.07725C8.90317 5.75181 9.43081 5.75181 9.75625 6.07725C10.0567 6.37765 10.0798 6.85034 9.82557 7.17725L9.75625 7.25576L7.84616 9.1665H17.5003C17.9606 9.1665 18.3337 9.5396 18.3337 9.99984C18.3337 10.4601 17.9606 10.8332 17.5003 10.8332H7.84616L9.75625 12.7439C10.0567 13.0443 10.0798 13.517 9.82557 13.8439L9.75625 13.9224C9.45584 14.2228 8.98315 14.2459 8.65624 13.9918L8.57774 13.9224L5.2444 10.5891L5.20991 10.5525L5.16394 10.4959L5.10422 10.4032L5.07837 10.3524L5.05023 10.2845L5.0302 10.2215L5.00602 10.0977L5.00033 9.99984Z"
          fill="#302F2F"
        />
      </svg>
    ),
    "message-chat": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.8931 15.8914C13.3463 18.4385 9.57514 18.9888 6.48901 17.5615C6.03341 17.3781 5.6599 17.2298 5.3048 17.2298C4.31573 17.2357 3.08463 18.1947 2.44479 17.5557C1.80495 16.9157 2.76471 15.6837 2.76471 14.6886C2.76471 14.3335 2.62234 13.9666 2.43893 13.5102C1.01102 10.4245 1.56208 6.65208 4.10887 4.10584C7.35999 0.85353 12.642 0.853531 15.8931 4.10501C19.1501 7.36234 19.1442 12.6399 15.8931 15.8914Z"
          stroke="#44449B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.283 10.3439H13.2905"
          stroke="#44449B"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.94221 10.3439H9.94971"
          stroke="#44449B"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.60139 10.3439H6.60889"
          stroke="#44449B"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    "reload-icon": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="15"
        width="15"
        viewBox="0 0 20 20"
      >
        <g transform="scale(-1,1) translate(-22,-2)">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            fill="#396DFA"
            d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
          />
        </g>
      </svg>
    ),
  };
  return iconSVGs[type];
}
export default Icon;
